webpackJsonp([1],{

/***/ "3jmS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HXhP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JAIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mjxm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ddc7ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("Om6c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3a0bff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("JAIY")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("Z1YF")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-13cf244c"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents', 'isMobileFontLarge'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleFontSize: 'TOGGLE_FONT_SIZE'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2c09f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"}},[_c('div',{staticClass:"nav-menu-button",class:{ mobileFontLarge: _vm.isMobileFontLarge },attrs:{"id":"mobile-font-size-toggle"},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"font-size-toggle-small"},[_vm._v("Aa")]),_vm._v(" "),_c('span',{staticClass:"font-size-toggle-large"},[_vm._v("Aa")])]),_vm._v(" "),_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("nSix")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-1d2c09f7"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d32c014e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("ij1X")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-d32c014e"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("r8RT")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19b17162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("Mjxm")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67fad68a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("lsaJ")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/material.css
var material = __webpack_require__("KUHQ");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: [],
      zoomValue: 1
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    VueSlider: vue_slider_component_umd_min_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "contentsPinned", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage", "fullscreenEnabled", "zoomScrollEnabled"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    slideZoom: "SLIDE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER",
    toggleFullscreen: "TOGGLE_FULLSCREEN"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    },
    updateSliderZoom: function updateSliderZoom() {
      Publish.$store.commit("SLIDE_ZOOM", { zoomValue: this.zoomValue });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4242b760","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.zoomScrollEnabled)?_c('li',{staticClass:"nav-bar__link nav-bar__zoom-slider"},[_c('vue-slider',{ref:"zoomSlider",attrs:{"min":1,"max":2,"interval":0.01,"tooltip-placement":'bottom'},on:{"change":function($event){_vm.updateSliderZoom()},"click":_vm.slideZoom},model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}})],1):_vm._e(),_vm._v(" "),(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomNavEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled && _vm.contentsPinned)?_c('li',{staticClass:"nav-bar__link hidden-large",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}}):(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled && !_vm.isMobile)?_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.toggleFullscreen}},[_c('feather-icon',{attrs:{"icon":"maximize"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("lJM2")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45475472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("HXhP")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be6e2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("OT+5")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'contentsPinned', 'contentsNumbers', 'contentsTitles']), {

    currentPageIndex: function currentPageIndex() {
      return this.page[0].pageIndex;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d79a731e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.currentPageIndex && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}},[(_vm.contentsNumbers)?_c('p',{staticClass:"contents-item__text--index"},[_vm._v("\n          "+_vm._s(_vm.currentPageIndex + 1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsTitles)?_c('p',{class:['contents-item__text--title', _vm.contentsPinned ? '' : '']},[_vm._v("\n          "+_vm._s(_vm.page[0].title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsPinned && _vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.currentPageIndex, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}}):_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]):_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("kzGI")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'showContents', 'contentsPinned']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688d3493","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[(_vm.contentsPinned)?_c('ul',{staticClass:"contents-list"},_vm._l((_vm.titledPages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})})):_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("hxKv")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07dfdf84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("hLNX")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277a16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b1b3a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("Tnot")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutubeOrOlympics: function isYoutubeOrOlympics() {
      return this.videoURL.search('youtube') !== -1 || this.videoURL.search('olympic') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70c81c71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutubeOrOlympics)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("3jmS")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e710b5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("o4GY")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-4e710b5e"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile", "fullscreenEnabled"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399a74da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomNavEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"maximize-2"}}),_vm._v(" "),_c('p',[_vm._v("Toggle fullscreen")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n\t\t\t\t\t\t\t\t\t\tc-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n\t\t\t\t\t\t\t\t\t\tc-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n\t\t\t\t\t\t\t\t\t\th85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n\t\t\t\t\t\t\t\t\t\tc-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n\t\t\t\t\t\t\t\t\t\tM123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n\t\t\t\t\t\t\t\t\t\tc-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n\t\t\t\t\t\t\t\t\t\tc-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n\t\t\t\t\t\t\t\t\t\tc0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n\t\t\t\t\t\t\t\t\t\tc6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n\t\t\t\t\t\t\t\t\t\tc3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n\t\t\t\t\t\t\t\t\t\tc-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n\t\t\t\t\t\t\t\t\t\tC70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n\t\t\t\t\t\t\t\t\t\tc-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n\t\t\t\t\t\t\t\t\t\tc6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n\t\t\t\t\t\t\t\t\t\tc14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n\t\t\t\t\t\t\t\t\t\tL154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("hIWI")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d498b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("WpSr")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'contentsPinned', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isMobileFontLarge'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35db5a76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'mobile-font-large': _vm.isMobileFontLarge, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{ref:"navBar",attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{class:{contentsPinned: _vm.contentsPinned},style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("dUvF")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';
var TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';
var SLIDE_ZOOM = 'SLIDE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
var UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Formula E - 2024-25 Season Sustainability Report",
  "shortTitle": "",
  "description": "",
  "width": 1263,
  "height": 893,
  "currentLanguage": "EN",
  "languages": [{
    code: "EN",
    text: "English",
    href: "#"
  }],
  "basePath": "/season2024-25",
  // "basePath": "",
  "companyLogo": "logo.png",
  "publishURL": "https://sustainabilityreport.fiaformulae.com/season2024-25/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "downloadPath": '/season2024-25/static/_content/formula-e-2024-25-sustainability-report.pdf',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true
    },
    "languagesEnabled": false,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScaleC 1-sub\" style=\"top:-147px;left:535px;\" src=\"/season2024-25/static/_content/1-sub-1.png\"/>\n      <img class=\"abs halfScaleC 1-sub\" style=\"top:-198px;left:532px;\" src=\"/season2024-25/static/_content/1-line-1.png\"/>\n      <img class=\"abs halfScaleC 1-title\" style=\"top:746px;left:511px;\" src=\"/season2024-25/static/_content/1-title-1.png\"/>\n      <img class=\"abs halfScaleC 1-title\" style=\"top:801px;left:425px;\" src=\"/season2024-25/static/_content/1-title-2.png\"/>\n      <img class=\"abs halfScaleC 1-logo\" style=\"top:-9px;left:821px;\" src=\"/season2024-25/static/_content/logo.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:406px; left:1159px; width:84px; height:86px;\"></div>     \n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.staggerFromTo(cOf(\"1-sub\"), 0.7, {opacity:0, x: -40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"1-title\"), 0.6, {opacity:0, x: 50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.5)\n          .fromTo(cOf(\"1-logo\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.8);\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "2024/25 SEASON SUSTAINABILITY REPORT  20 24 / 25 RACING FOR BETTER FUTURES"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(3);\" style=\"top:88px; left:258px; width:390px; height:31px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(4);\" style=\"top:138px; left:262px; width:378px; height:21px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(5);\" style=\"top:163px; left:262px; width:378px; height:21px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(7);\" style=\"top:192px; left:262px; width:378px; height:21px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(10);\" style=\"top:219px; left:262px; width:378px; height:21px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(11);\" style=\"top:306px; left:258px; width:390px; height:61px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(12);\" style=\"top:378px; left:262px; width:378px; height:21px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(14);\" style=\"top:409px; left:262px; width:378px; height:38px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(15);\" style=\"top:459px; left:262px; width:378px; height:38px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(16);\" style=\"top:501px; left:262px; width:378px; height:21px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(17);\" style=\"top:565px; left:258px; width:390px; height:31px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(18);\" style=\"top:605px; left:262px; width:378px; height:21px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(20);\" style=\"top:633px; left:262px; width:378px; height:21px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(21);\" style=\"top:663px; left:262px; width:378px; height:40px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(22);\" style=\"top:707px; left:262px; width:378px; height:21px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(23);\" style=\"top:735px; left:262px; width:378px; height:21px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(24);\" style=\"top:760px; left:262px; width:378px; height:21px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(25);\" style=\"top:88px; left:845px; width:390px; height:61px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(26);\" style=\"top:163px; left:845px; width:365px; height:21px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(28);\" style=\"top:192px; left:845px; width:365px; height:21px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(29);\" style=\"top:219px; left:845px; width:365px; height:21px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(30);\" style=\"top:306px; left:845px; width:390px; height:61px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(31);\" style=\"top:378px; left:845px; width:365px; height:21px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(33);\" style=\"top:409px; left:845px; width:365px; height:21px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(34);\" style=\"top:434px; left:845px; width:365px; height:40px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(35);\" style=\"top:482px; left:845px; width:365px; height:21px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(36);\" style=\"top:572px; left:845px; width:276px; height:31px;\"></div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg2Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg2Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "1 2 3  CONTENT  CONTENTS  02  CONTENTS  INTRODUCTION		  03  CEO Foreword  4  Leading the Race for Progress  5  Season 2024/25 Stories  7  Governance  10  FORMULA EXCELLENCE		  11  They Pledge, We Deliver  12  Integrating Sustainability at Race Pace  14  Strengthening Oversight and Accountability  15  Maintaining our Leadership Position  16  FORMULA EQUITY 17 Bringing Communities into the Race  18  A Positive Legacy in Host Communities  20  Creating Opportunities with FIA Girls on Track  21  Delivering Social and Economic Impact  22  Community Benefits and Opportunities  23  A More Inclusive Workforce  24  4 5 6  2024/25 SEASON  FORMULA ENVIRONMENT  25  Net Zero is our Finish Line  26  Our Carbon Impact  28  Winning the Race on Emissions  29  FORMULA ECOSYSTEM  30  Value Through Values  31  Partners on our Journey to Net Zero  33  Envision Racing Named Sustainability Champion  34  Conversations to Unlock Ideas  35  GRI INDEX  36"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:406px; left:1159px; width:84px; height:86px;\"></div>     \n\n      ",
    "script": "\n        function onPageEnter() {\n          pg3Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "1 INTRO INTRO INTRO INTRO  INTRODUCTION"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "CEO FOREWORD The 2024/25 Season of the ABB FIA Formula E World Championship marked a pivotal shift in our journey. Formula E was created to prove that sport can be a powerful engine for innovation, human progress, and positive change, and we took that purpose to new heights by moving from setting ambitions to executing real, measurable action. As a sport with sustainability in our DNA, we’ve always known that our responsibilities go beyond the track. During the 2024/25 Season, we focused on implementation, embedding sustainable practices deep into our global operations, strengthening accountability across our supply chains, and delivering tangible outcomes for our host communities. From breaking ground on gender equality in motorsport to pioneering new standards in climate accounting, we strengthened our impact across our strategic pillars: Formula Excellence, Formula Equity, Formula Environment, and Formula Ecosystem. A major milestone came in our approach to climate action. As expectations around  04  INTRODUCTION  net zero continue to evolve, we progressed from traditional carbon neutrality towards a science-based, independently verified pathway centred on real emissions reductions, transparent reporting, and robust long-term planning. Following a rigorous independent audit, Formula E became the first sport certified under the BSI Net Zero Pathway, reinforcing our commitment to credible and transparent climate leadership aligned with ISO 14064 and IWA 42 standards. Equal progress was made on social impact and breaking down barriers across motorsport. In November 2024, we hosted the first all-women test session in FIA World Championship history, giving 17 drivers the opportunity to experience our GEN3 Evo race car and work directly with engineers. Beyond the track, five participants secured roles with Formula E teams, with three progressing into permanent positions within our ecosystem. At the same time, our Driving Force education initiative expanded its reach significantly, inspiring more than 61,000 pupils through teacher-led content and hosting hands-on STEM workshops across Jeddah, Miami, and London.  2024/25 SEASON  Jeff Dodds Chief Executive Officer, Formula E  Crucially, our efforts continue to set the benchmark on the global stage. For the fourth consecutive year, Formula E was ranked as the world's most sustainable sport by the Global Sustainability Benchmark in Sport (GSBS), earning an overall score of 85% and topping both the Environmental and Social categories among 78 global sports organisations. This recognition is a testament to the relentless dedication of our teams, partners, suppliers, manufacturers, race promoters, host cities, and wider Formula E community. At Formula E, we do not view sustainability as a finish line to cross, but as a continuous pursuit to act faster, push boundaries, and deliver more. The 2024/25 Season demonstrated what is possible when purpose meets implementation, and as we look ahead, our drive to translate purpose into lasting action only grows stronger."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg5Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "LEADING THE RACE FOR PROGRESS Formula E was created to demonstrate that sport can be a platform for innovation, human progress and positive change. During the 2024/25 Season, that mission took another important step forward. Across the Championship, the focus was increasingly on implementation: continually embedding sustainability in the way we operate, strengthening accountability, improving how we measure impact and delivering tangible outcomes for our communities and wider world. The result was a season defined not by new ambitions, but by progress. One of the  05  INTRODUCTION  most significant milestones came in our approach to climate action. As expectations around Net Zero continue to evolve, Formula E continued its transition from carbon neutrality towards a science-based, independently verified pathway centred on emissions reductions, robust carbon accounting and long-term planning. Following an external audit, Formula E became the first sport certified under the BSI Net Zero Pathway, reinforcing our commitment to credible and transparent climate leadership. But the 2024/25 Season was about more than climate action alone.  2024/25 SEASON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg6Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "LEADING THE RACE FOR PROGRESS  From enhanced emissions reporting to the introduction of a socio-economic impact framework, we sought to ensure that progress is supported by evidence, transparency and accountability.  (CONTINUED)  We expanded opportunities for women in motorsport through the first all-women test session in FIA World Championship history. We more than tripled the number of people positively impacted through our social impact programmes. We invested in local communities across our race calendar, reached thousands of young people through sustainability education initiatives and continued to strengthen the governance systems that underpin our long-term approach.  None of this work happens in isolation. It is made possible by the collective efforts of our teams, partners, suppliers, manufacturers, race promoters, host cities and wider Formula E community. This report tells the story of that progress. It reflects a season in which sustainability became further embedded across the championship and demonstrates how Formula E continues to translate its purpose into action.  At the same time, we developed new ways of understanding and measuring our impact.  06  INTRODUCTION  2024/25 SEASON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"abs halfScale 7-number\" style=\"top:440px;left:749px;\" src=\"/season2024-25/static/_content/7-no-1.png\"/>\n      <h1 id=\"7-no\" class=\"abs feSans-miniBd 7-no\" style=\"top:560px;left:747px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 17}' ></h1>\n      <h1 id=\"7-no\" class=\"abs feSans-miniBd 7-no\" style=\"top:560px;left:986px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 3}' ></h1>\n      <h1 id=\"7-no\" class=\"abs feSans-miniBd 7-no\" style=\"top:660px;left:747px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 5}' ></h1>\n      <h1 id=\"7-no\" class=\"abs feSans-miniBd 7-no\" style=\"top:660px;left:986px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 3}' ></h1>\n\n      <!-- pop one -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 7-click-1\" style=\"top:715px;left:60px;\" onclick=\"showSevenPopOne()\" src=\"/season2024-25/static/_content/7-click-1.png\"/>\n      <div id=\"7-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 7-pop-1\" style=\"top:278px;left:172px;\" src=\"/season2024-25/static/_content/7-pop-1.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:736px;left:203px;width:285px;height:43px;\" onclick=\"hideOverlay('7-pop-1')\"></div>\n      </div>\n\n      <!-- pop two -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 7-click-2\" style=\"top:26px;left:704px;\" onclick=\"showSevenPopTwo()\" src=\"/season2024-25/static/_content/7-click-2.png\"/>\n      <div id=\"7-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 7-pop-2\" style=\"top:54px;left:714px;\" src=\"/season2024-25/static/_content/7-pop-2.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:73px;left:1157px;width:42px;height:42px;\" onclick=\"hideOverlay('7-pop-2')\"></div>\n      </div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg7Anim = new TimelineMax();\n          pg7Anim.fromTo(cOf(\"7-number\"), 0.6, {opacity:0, x: 25}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"7-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"7-no\")[0])}}, 1.0)\n          .fromTo(cOf(\"7-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"7-no\")[1])}}, 1.0)\n          .fromTo(cOf(\"7-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"7-no\")[2])}}, 1.0)\n          .fromTo(cOf(\"7-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"7-no\")[3])}}, 1.0);\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function showSevenPopOne() {\n          showOverlay('7-pop-1')\n        }\n\n        function closeSevenPopOne() {\n          hideOverlay('7-pop-1')\n        }\n\n        function showSevenPopTwo() {\n          showOverlay('7-pop-2')\n        }\n\n        function CloseSevenPopTwo() {\n          hideOverlay('7-pop-2')\n        }\n\n        function onPageLeave() {\n          pg7Anim.stop();\n          resetNumbers(\"7-no\");\n          closeSevenPopOne();\n          removeContentLinks()\n        }\n      ",
    "searchText": "2024/25 2024/25  CLICK TO SEE ALL-WOMEN TEST DRIVER LINE-UP  2024/25 2024/25 2024/25 2024/25 2024/25 2024/25  SEASON STORIES  2024/25  1 07  1  ALL-WOMEN TEST BREAKS DOWN BARRIERS  ST  Motorsport has no shortage of talented women drivers. The challenge has often been access to opportunities at the highest level. In November 2024, we hosted the first all-women test session in the history of an FIA World Championship, giving 17 drivers the opportunity to experience Formula E machinery and work directly with our teams.  INTRODUCTION  all-women test session in FIA World Championship history  17  3  5  3  drivers participated  participants secured Formula E team roles  CLICK TO READ MORE  2024/25 SEASON  hours of track running  participants progressed into permanent positions"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n      \n      <h1 id=\"8-no\" class=\"abs feSans-miniBd 8-no\" style=\"top:86px;left:972px; font-size: 3.4em; font-weight: 300; color: #0000ff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 50, \"append\": \"%\"}' ></h1>\n      <h1 id=\"8-no\" class=\"abs feSans-miniBd 8-no\" style=\"top:209px;left:973px; font-size: 3.4em; font-weight: 300; color: #0000ff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 27.5, \"decimals\": 1, \"append\": \"%\"}' ></h1>\n      <h1 id=\"8-no\" class=\"abs feSans-miniBd 8-no\" style=\"top:325px;left:973px; font-size: 3.4em; font-weight: 300; color: #0000ff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 90, \"append\": \"%\"}' ></h1>\n\n      <!-- pop one -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 8-click-1\" style=\"top:415px;left:400px;\" onclick=\"showEightPopOne()\" src=\"/season2024-25/static/_content/8-click-1.png\"/>\n      <div id=\"8-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 8-pop-1\" style=\"top:98px;left:172px;\" src=\"/season2024-25/static/_content/8-pop-1.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:726px;left:868px;width:285px;height:43px;\" onclick=\"hideOverlay('8-pop-1')\"></div>\n      </div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim.fromTo(cOf(\"8-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"8-no\")[0])}}, 1.0)\n          .fromTo(cOf(\"8-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"8-no\")[1])}}, 1.0)\n          .fromTo(cOf(\"8-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"8-no\")[2])}}, 1.0);\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function showEightPopOne() {\n          showOverlay('8-pop-1')\n        }\n\n        function closeEightPopOne() {\n          hideOverlay('8-pop-1')\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n          resetNumbers(\"8-no\");\n          closeEightPopOne();\n          removeContentLinks()\n        }\n      ",
    "searchText": "2024/25 2024/25 2024/25 2024/25 2024/25 2024/25 2024/25 2024/25  SEASON STORIES  2024/25  FIRST NET ZERO PATHWAY CERTIFIED SPORT Net zero has become one of the most widely used terms in sustainability, and is also one of the most misunderstood. When we first established our carbon neutrality programme, it reflected the standards and expectations of the time. But as climate science, regulation and stakeholder expectations have evolved, so too has the definition of what credible climate action looks like.  Today, organisations are increasingly expected to demonstrate how they will reduce emissions over time, supported by robust data, transparent reporting and independently verified plans. The focus has shifted from offsetting emissions to reducing them. In the 2024/25 Season, we continued to evolve our approach in line with that change.  CLICK TO READ MORE  2 08  INTRODUCTION  2024/25 SEASON  50%  Scope 1 & 2 reduction target by 2030  27.5% Scope 3 reduction target by 2030  90%  Scope 1, 2 & 3 reduction target by 2050 at the latest"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n      \n      <!-- pop one -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 9-click-1\" style=\"top:702px;left:67px;\" onclick=\"showNinePopOne()\" src=\"/season2024-25/static/_content/9-click-1.png\"/>\n      <div id=\"9-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 9-pop-1\" style=\"top:198px;left:172px;\" src=\"/season2024-25/static/_content/9-pop-1.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:736px;left:203px;width:285px;height:43px;\" onclick=\"hideOverlay('9-pop-1')\"></div>\n      </div>\n\n      <!-- pop two -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 9-click-2\" style=\"top:702px;left:556px;\" onclick=\"showNinePopTwo()\" src=\"/season2024-25/static/_content/9-click-2.png\"/>\n      <div id=\"9-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 9-pop-2\" style=\"top:50px;left:172px;\" src=\"/season2024-25/static/_content/9-pop-2.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:71px;left:1152px;width:43px;height:43px;\" onclick=\"hideOverlay('9-pop-2')\"></div>\n\n        <!-- animations -->\n\n        <h1 id=\"9-no\" class=\"abs feSans-miniBd 9-no\" style=\"top:181px;left:648px; font-size: 4.2em; font-weight: 300; color: #ffc400; padding: 0px; margin: 0px;\"  data-number='{\"to\": 61678, \"comma\": true}' ></h1>\n        <h1 id=\"9-no\" class=\"abs feSans-miniBd 9-no\" style=\"top:266px;left: 701px; font-size: 4.2em; font-weight: 300; color: #ffc400; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1288, \"comma\": true}' ></h1>\n\n        <img class=\"abs halfScaleC 9-sub\" style=\"top:356px;left:179px;\" src=\"/season2024-25/static/_content/9-pop-2-sub-1.png\"/>\n        <img class=\"abs halfScaleC 9-piechart\" style=\"top:358px;left:217px;\" src=\"/season2024-25/static/_content/9-pop-2-piechart-1.png\"/>\n        <h1 id=\"9-no\" class=\"abs feSans-miniBd 9-no\" style=\"top:411px;left:325px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;\"  data-number='{\"to\": 77, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScaleC 9-text\" style=\"top:460px;left:210px;\" src=\"/season2024-25/static/_content/9-pop-2-text-1.png\"/>\n\n        <img class=\"abs halfScaleC 9-piechart\" style=\"top:358px;left:569px;\" src=\"/season2024-25/static/_content/9-pop-2-piechart-2.png\"/>\n        <h1 id=\"9-no\" class=\"abs feSans-miniBd 9-no\" style=\"top:411px;left:676px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;\"  data-number='{\"to\": 77, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScaleC 9-text\" style=\"top:461px;left:590px;\" src=\"/season2024-25/static/_content/9-pop-2-text-2.png\"/>\n\n        <img class=\"abs halfScaleC 9-piechart\" style=\"top:358px;left:868px;\" src=\"/season2024-25/static/_content/9-pop-2-piechart-3.png\"/>\n        <h1 id=\"9-no\" class=\"abs feSans-miniBd 9-no\" style=\"top:411px;left:974px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;\"  data-number='{\"to\": 2, \"append\": \"/\"}' ></h1>\n        <h1 id=\"9-no\" class=\"abs feSans-miniBd 9-no\" style=\"top:411px;left:1038px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;\"  data-number='{\"to\": 3}' ></h1>\n        <img class=\"abs halfScaleC 9-text\" style=\"top:461px;left:886px;\" src=\"/season2024-25/static/_content/9-pop-2-text-3.png\"/>\n\n\n        <img class=\"abs halfScaleC 9-sub\" style=\"top:549px;left:179px;\" src=\"/season2024-25/static/_content/9-pop-2-sub-2.png\"/>\n        <img class=\"abs halfScaleC 9-piechart\" style=\"top:552px;left:217px;\" src=\"/season2024-25/static/_content/9-pop-2-piechart-4.png\"/>\n        <h1 id=\"9-no\" class=\"abs feSans-miniBd 9-no\" style=\"top:603px;left:325px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;\"  data-number='{\"to\": 90, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScaleC 9-text\" style=\"top:654px;left:205px;\" src=\"/season2024-25/static/_content/9-pop-2-text-4.png\"/>\n\n        <img class=\"abs halfScaleC 9-piechart\" style=\"top:552px;left:569px;\" src=\"/season2024-25/static/_content/9-pop-2-piechart-5.png\"/>\n        <h1 id=\"9-no\" class=\"abs feSans-miniBd 9-no\" style=\"top:603px;left:674px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;\"  data-number='{\"to\": 90, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScaleC 9-text\" style=\"top:654px;left:588px;\" src=\"/season2024-25/static/_content/9-pop-2-text-5.png\"/>\n\n        <img class=\"abs halfScaleC 9-piechart\" style=\"top:552px;left:866px;\" src=\"/season2024-25/static/_content/9-pop-2-piechart-6.png\"/>\n        <h1 id=\"9-no\" class=\"abs feSans-miniBd 9-no\" style=\"top:603px;left:973px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;\"  data-number='{\"to\": 83, \"append\": \"%\"}' ></h1>\n        <img class=\"abs halfScaleC 9-text\" style=\"top:654px;left:879px;\" src=\"/season2024-25/static/_content/9-pop-2-text-6.png\"/>\n      </div>\n\n      <img class=\"abs halfScaleC 9-icon\" style=\"top:644px;left:666px;\" src=\"/season2024-25/static/_content/9-icon.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg9Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n \n        function showNinePopOne() {\n          showOverlay('9-pop-1')\n        }\n\n        function closeNinePopOne() {\n          hideOverlay('9-pop-1')\n        }\n\n        function showNinePopTwo() {\n          showOverlay('9-pop-2');\n          pg9Anim = new TimelineMax();\n          pg9Anim.fromTo(cOf(\"9-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"9-no\")[0])}}, 1.0)\n          .fromTo(cOf(\"9-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"9-no\")[1])}}, 1.1)\n          .fromTo(cOf(\"9-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n          .fromTo(cOf(\"9-piechart\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.4)\n          .fromTo(cOf(\"9-text\"), 0.6, {opacity:0, y: 25}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.6)\n          .fromTo(cOf(\"9-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"9-no\")[2])}}, 1.7)\n          .fromTo(cOf(\"9-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"9-no\")[3])}}, 1.7)\n          .fromTo(cOf(\"9-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"9-no\")[4])}}, 1.7)\n          .fromTo(cOf(\"9-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"9-no\")[5])}}, 1.7)\n          .fromTo(cOf(\"9-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"9-no\")[6])}}, 1.7)\n          .fromTo(cOf(\"9-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"9-no\")[7])}}, 1.7)\n          .fromTo(cOf(\"9-no\")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"9-no\")[8])}}, 1.7);\n        }\n\n        function closeNinePopTwo() {\n          hideOverlay('9-pop-2')\n          resetNumbers(\"9-no\");\n        }\n\n        function onPageLeave() {\n          pg9Anim.stop();\n          resetNumbers(\"9-no\");\n          closeNinePopOne();\n          closeNinePopTwo();\n          removeContentLinks()\n        }\n      ",
    "searchText": "2024/25 2024/25 2024/25 2024/25 2024/25 2024/25 2024/25 2024/25  SEASON STORIES  2024/25  3 09  INTRODUCTION  INSPIRING THE NEXT GENERATION OF CHANGEMAKERS Many young people are concerned about the future of the planet and need support to believe they can play a meaningful role in shaping it. That is the idea behind Driving Force, Formula E’s sustainability and STEM education programme designed to connect the excitement of electric racing with real-world challenges and inspire the next generation of changemakers.  CLICK TO READ MORE  CLICK TO SEE THE NUMBERS  2024/25 SEASON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg10Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "GOVERNANCE  MANAGEMENT SYSTEMS AND STANDARDS  FORMULA E HAS A ROBUST GOVERNANCE STRUCTURE IN PLACE TO ENSURE SUSTAINABILITY REMAINS A CORE STRATEGIC PRIORITY ACROSS THE BUSINESS.  BOARD-LEVEL ENGAGEMENT AND OVERSIGHT The Board holds ultimate responsibility for sustainability-related decisionmaking. It reviews strategy, oversees major capital expenditures, guides annual budgets and shapes innovation and R&D priorities. Board-level oversight of sustainability-related issues takes place on a case-by-case basis, with key matters reviewed and addressed as they arise.  CEO ROLE IN SUSTAINABILITY LEADERSHIP  STRATEGIC OVERSIGHT Our VP of Sustainability leads the strategic assessment and management of sustainabilityrelated risks and opportunities. Sustainability considerations are integrated into Leadership Team discussions as needed, helping to inform strategic, financial and operational planning.  FINANCIAL INCENTIVES  Sustainability is embedded within our business KPIs, creating clear priorities and performance expectations across the company. For relevant employees, achievement against these KPIs also influences bonus-related financial incentives.  Our CEO holds ultimate accountability for the management of sustainability-related risks and opportunities, delegating responsibility for specific issues to the relevant departments as appropriate.  10  INTRODUCTION  2024/25 SEASON  Our sustainability management system is underpinned by internationally recognised frameworks and standards, including ISO 20121 for sustainable event management, ISO 14064 for greenhouse gas accounting and verification, IWA 42 for net zero guidelines and the UNFCCC Sports for Climate Action Framework. Together, these frameworks define sustainability-related roles, responsibilities and actions across all levels of the business. Key responsibilities are embedded within job descriptions, while sustainability-related KPIs, including our science-based targets (SBTs), support decision-making and drive emissions reductions."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:406px; left:1159px; width:84px; height:86px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          \n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "2 FORMULA FORMULA FORMULA FORMULA  EXCELLENCE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "A SHARPER FOCUS ON IMPLEMENTATION  THIS SECTION OF THE REPORT  THEY PLEDGE, WE DELIVER The 2024/25 Season marked an important shift in Formula E's sustainability journey. Having spent previous seasons building frameworks, policies and management systems, implementation became more focused.  INTEGRATING  From governance and climate action to human rights and supplier accountability, sustainability became increasingly embedded in the way we operate. This chapter explores how stronger systems, clearer accountability and more robust data are helping turn ambition into action across the Championship.  We built and promoted human  12  FORMULA EXCELLENCE  SUSTAINABILITY AT RACE PACE  The emphasis was on implementation of sustainability policies across the business. STRENGTHENING OVERSIGHT AND ACCOUNTABILITY rights and supplier policies. MAINTAINING OUR LEADERSHIP POSITION Ranked number one for the fourth year in a row by the Global Sustainability Benchmark in Sport (GSBS).  2024/25 SEASON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"abs halfScale 13-number\" style=\"top:65px;left:495px;\" src=\"/season2024-25/static/_content/13-no-1.png\"/>\n\n      <h1 id=\"13-no\" class=\"abs feSans-miniBd 13-no\" style=\"top:358px;left:679px; font-size: 8.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 85}' ></h1>\n\n      <img class=\"abs halfScale 13-perc\" style=\"top:401px;left:902px;\" src=\"/season2024-25/static/_content/percentage.png\"/>\n      <img class=\"abs halfScale 13-perc\" style=\"top:381px;left:1000px;\" src=\"/season2024-25/static/_content/13-block-1.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg13Anim = new TimelineMax();\n          pg13Anim.fromTo(cOf(\"13-number\"), 0.6, {opacity:0, x: 25}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          pg13Anim.fromTo(cOf(\"13-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no\")[0])}}, 1.2);\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg13Anim.stop();\n          resetNumbers(\"13-no\");\n          removeContentLinks()\n        }\n      ",
    "searchText": "FORMULA FORMULA FORMULA FORMULA  1  ST  IN THE GLOBAL SUSTAINABILITY BENCHMARK IN SPORT RANKINGS  EXCELLENCE S_11  85 BEST  %  IN NUMBERS IN NUMBERS IN NUMBERS IN NUMBERS  OVERALL SCORE  - SOCIAL PERFORMANCE - ENVIRONMENTAL PERFORMANCE  13  FORMULA EXCELLENCE  2024/25 SEASON  DEDICATED ESG POLICY DEVELOPED MOST COMPREHENSIVE IMPACT DATA COLLECTION"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n\n        <!-- pop one -->\n        <img class=\"abs halfScaleC halfpulse animatedpulse pointer 14-click-1\" style=\"top:414px;left:436px;\" onclick=\"showFourteenPopOne()\" src=\"/season2024-25/static/_content/14-click-1.png\"/>\n        <div id=\"14-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"abs halfScale 14-pop-1\" style=\"top:424px;left:38px;\" src=\"/season2024-25/static/_content/14-pop-1.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:433px;left:582px;width:285px;height:43px;\" onclick=\"hideOverlay('14-pop-1')\"></div>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:706px;left:1142px;width:43px;height:43px;\" onclick=\"hideOverlay('14-pop-1')\"></div>\n        </div>\n\n        <!-- pop two -->\n        <img class=\"abs halfScaleC halfpulse animatedpulse pointer 14-click-2\" style=\"top:174px;left:783px;\" onclick=\"showFourteenPopTwo()\" src=\"/season2024-25/static/_content/14-click-2.png\"/>\n        <div id=\"14-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"abs halfScale 14-pop-2\" style=\"top:54px;left:856px;\" src=\"/season2024-25/static/_content/14-pop-2.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:725px;left:1015px;width:42px;height:42px;\" onclick=\"hideOverlay('14-pop-2')\"></div>\n        </div>\n  \n        <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n        \n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function showFourteenPopOne() {\n          showOverlay('14-pop-1')\n        }\n\n        function closeFourteenPopOne() {\n          hideOverlay('14-pop-1')\n        }\n\n        function showFourteenPopTwo() {\n          showOverlay('14-pop-2')\n        }\n\n        function closeFourteenPopTwo() {\n          hideOverlay('14-pop-2')\n        }\n\n        function onPageLeave() {\n          pg3Anim.stop();\n          closeFourteenPopOne();\n          closeFourteenPopTwo();\n          removeContentLinks()\n        }\n      ",
    "searchText": "INTEGRATING SUSTAINABILITY AT RACE PACE The 2024/25 Season marked an important shift in Formula E’s sustainability journey. While previous seasons focused on understanding risks, developing frameworks and establishing policies, the emphasis this year was on implementation.  Across the business, sustainability requirements were increasingly embedded into operational processes, supplier relationships, contractual arrangements and management systems. This helped ensure that sustainability considerations were reflected not only in strategic decisionmaking, but also in day-to-day activities throughout the championship.  CLICK TO READ MORE  14  FORMULA EXCELLENCE  2024/25 SEASON  CLICK TO READ ABOUT DATA COLLECTION"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n      \n        <!-- pop one -->\n        <img class=\"abs halfScaleC halfpulse animatedpulse pointer 15-click-1\" style=\"top:255px;left:542px;\" onclick=\"showFifteenPopOne()\" src=\"/season2024-25/static/_content/15-click-1.png\"/>\n        <div id=\"15-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"abs halfScale 15-pop-1\" style=\"top:271px;left:728px;\" src=\"/season2024-25/static/_content/15-pop-1.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:703px;left:942px;width:43px;height:43px;\" onclick=\"hideOverlay('15-pop-1')\"></div>\n        </div>\n\n        <!-- pop two -->\n        <img class=\"abs halfScaleC halfpulse animatedpulse pointer 15-click-1\" style=\"top:677px;left:743px;\" onclick=\"showFifteenPopTwo()\" src=\"/season2024-25/static/_content/15-click-2.png\"/>\n        <div id=\"15-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"abs halfScale 15-pop-2\" style=\"top:456px;left:391px;\" src=\"/season2024-25/static/_content/15-pop-2.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:469px;left:1138px;width:43px;height:43px;\" onclick=\"hideOverlay('15-pop-2')\"></div>\n        </div>\n\n        <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg15Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function showFifteenPopOne() {\n          showOverlay('15-pop-1')\n        }\n\n        function closeFifteenPopOne() {\n          hideOverlay('15-pop-1')\n        }\n\n        function showFifteenPopTwo() {\n          showOverlay('15-pop-2')\n        }\n\n        function closeFifteenPopTwo() {\n          hideOverlay('15-pop-2')\n        }\n\n        function onPageLeave() {\n          pg3Anim.stop();\n          closeFifteenPopOne();\n          closeFifteenPopTwo();\n          removeContentLinks()\n        }\n      ",
    "searchText": "STRENGTHENING OVERSIGHT AND ACCOUNTABILITY We continued to strengthen the systems and processes that support responsible business practices across the Championship.  Insights from these reviews help inform future actions and strengthen oversight of suppliers, contractors and event operations.  Respect for human rights forms part of Formula E’s broader approach to responsible business. During the 2024/25 Season, a number of policies, controls and processes were further embedded across the organisation, including our Human and Child Rights Policy, Whistleblowing Policy, supplier due diligence procedures and grievance mechanisms.  This work supports ongoing efforts to promote fair working conditions, worker welfare, health and safety, responsible employment  practices and respect for local labour requirements across all markets in which we operate.  CLICK TO READ ABOUT REPORTING REQUIREMENTS FOR SUPPLIERS  AN INTEGRATED MANAGEMENT APPROACH  These measures support the identification, prevention and management of human rights risks across our operations and supply chain. We also continued to undertake modern slavery assessments and audits at selected race locations based on risk considerations.  15  FORMULA EXCELLENCE  CLICK TO READ MORE  2024/25 SEASON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n      \n      <!-- pop one -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 16-click-1\" style=\"top:481px;left:-90px;\" onclick=\"showSixteenPopOne()\" src=\"/season2024-25/static/_content/16-click-1.png\"/>\n      <div id=\"16-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 16-pop-1\" style=\"top:204px;left:36px;\" src=\"/season2024-25/static/_content/16-pop-1.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:502px;left:52px;width:285px;height:43px;\" onclick=\"hideOverlay('16-pop-1')\"></div>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:727px;left:695px;width:43px;height:43px;\" onclick=\"hideOverlay('16-pop-1')\"></div>\n      </div>\n\n      <!-- pop two -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 16-click-2\" style=\"top:-39px;left:851px;\" onclick=\"showSixteenPopTwo()\" src=\"/season2024-25/static/_content/16-click-2.png\"/>\n      <div id=\"16-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 16-pop-2\" style=\"top:69px;left:972px;\" src=\"/season2024-25/static/_content/16-pop-2.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:83px;left:1160px;width:43px;height:43px;\" onclick=\"hideOverlay('16-pop-2')\"></div>\n\n        <!-- animations -->\n        <h1 id=\"16-no\" class=\"abs feSans-miniBd 16-no\" style=\"top:387px;left:1014px; font-size: 4.3em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 85}' ></h1>\n        <img class=\"abs halfScaleC 16-perc\" style=\"top:392px;left:1100px;\" src=\"/season2024-25/static/_content/percentage-white.png\"/>\n\n        <h1 id=\"16-no\" class=\"abs feSans-miniBd 16-no\" style=\"top:511px;left:1066px; font-size: 1.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 57, \"append\": \"%\"}' ></h1>\n\n        <h1 id=\"16-no\" class=\"abs feSans-miniBd 16-no\" style=\"top:601px;left:1078px; font-size: 1.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 78}' ></h1>\n\n        <h1 id=\"16-no\" class=\"abs feSans-miniBd 16-no\" style=\"top:688px;left:1061px; font-size: 1.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1700, \"comma\" : true, \"append\": \"+\"}' ></h1>\n      </div>\n\n      <!-- pop three -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 16-click-3\" style=\"top:628px;left:-90px;\" onclick=\"showSixteenPopThree()\" src=\"/season2024-25/static/_content/16-click-3.png\"/>\n      <div id=\"16-pop-3\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 16-pop-3\" style=\"top:68px;left:51px;\" src=\"/season2024-25/static/_content/16-pop-3.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:89px;left:1143px;width:43px;height:43px;\" onclick=\"hideOverlay('16-pop-3')\"></div>\n\n        <!-- animations -->\n\n        <img class=\"abs halfScale 16-text\" style=\"top:199px;left:96px;\" src=\"/season2024-25/static/_content/16-pop-3-text-1.png\"/>\n        <img class=\"abs halfScale 16-bar\" style=\"top:223px;left:94px;\" src=\"/season2024-25/static/_content/16-pop-3-bar-1.png\"/>\n        <img class=\"abs halfScaleC 16-line-dotted\" style=\"top:153px;left:727px;\" src=\"/season2024-25/static/_content/16-pop-3-industry-line.png\"/>\n        <img class=\"abs halfScaleC 16-line\" style=\"top:147px;left:998px;\" src=\"/season2024-25/static/_content/16-pop-3-formulae-line.png\"/>\n        <h1 id=\"16-no\" class=\"abs feSans-miniBd 16-no\" style=\"top:180px;left:759px; font-size: 1.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 62,\"append\": \"%\"}' ></h1>\n        <h1 id=\"16-no\" class=\"abs feSans-miniBd 16-no\" style=\"top:177px;left:1027px; font-size: 1.8em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 88,\"append\": \"%\"}' ></h1>\n\n        <img class=\"abs halfScale 16-text\" style=\"top:292px;left:96px;\" src=\"/season2024-25/static/_content/16-pop-3-text-2.png\"/>\n        <img class=\"abs halfScale 16-bar\" style=\"top:315px;left:94px;\" src=\"/season2024-25/static/_content/16-pop-3-bar-2.png\"/>\n        <img class=\"abs halfScaleC 16-line-dotted\" style=\"top:245px;left:549px;\" src=\"/season2024-25/static/_content/16-pop-3-industry-line.png\"/>\n        <img class=\"abs halfScaleC 16-line\" style=\"top:239px;left:905px;\" src=\"/season2024-25/static/_content/16-pop-3-formulae-line.png\"/>\n        <h1 id=\"16-no\" class=\"abs feSans-miniBd 16-no\" style=\"top:279px;left:580px; font-size: 1.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 45,\"append\": \"%\"}' ></h1>\n        <h1 id=\"16-no\" class=\"abs feSans-miniBd 16-no\" style=\"top:272px;left:934px; font-size: 1.8em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 79,\"append\": \"%\"}' ></h1>\n\n        <img class=\"abs halfScale 16-text\" style=\"top:389px;left:96px;\" src=\"/season2024-25/static/_content/16-pop-3-text-3.png\"/>\n        <img class=\"abs halfScale 16-bar\" style=\"top:410px;left:94px;\" src=\"/season2024-25/static/_content/16-pop-3-bar-3.png\"/>\n        <img class=\"abs halfScaleC 16-line-dotted\" style=\"top:339px;left:685px;\" src=\"/season2024-25/static/_content/16-pop-3-industry-line.png\"/>\n        <img class=\"abs halfScaleC 16-line\" style=\"top:334px;left:998px;\" src=\"/season2024-25/static/_content/16-pop-3-formulae-line.png\"/>\n        <h1 id=\"16-no\" class=\"abs feSans-miniBd 16-no\" style=\"top:371px;left:717px; font-size: 1.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 58,\"append\": \"%\"}' ></h1>\n        <h1 id=\"16-no\" class=\"abs feSans-miniBd 16-no\" style=\"top:366px;left:1027px; font-size: 1.8em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 88,\"append\": \"%\"}' ></h1>\n\n        <img class=\"abs halfScale 16-text\" style=\"top:483px;left:96px;\" src=\"/season2024-25/static/_content/16-pop-3-text-4.png\"/>\n        <img class=\"abs halfScale 16-bar\" style=\"top:504px;left:94px;\" src=\"/season2024-25/static/_content/16-pop-3-bar-4.png\"/>\n        <img class=\"abs halfScaleC 16-line-dotted\" style=\"top:434px;left:695px;\" src=\"/season2024-25/static/_content/16-pop-3-industry-line.png\"/>\n        <img class=\"abs halfScaleC 16-line\" style=\"top:428px;left:956px;\" src=\"/season2024-25/static/_content/16-pop-3-formulae-line.png\"/>\n        <h1 id=\"16-no\" class=\"abs feSans-miniBd 16-no\" style=\"top:463px;left:727px; font-size: 1.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 59,\"append\": \"%\"}' ></h1>\n        <h1 id=\"16-no\" class=\"abs feSans-miniBd 16-no\" style=\"top:461px;left:985px; font-size: 1.8em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 84,\"append\": \"%\"}' ></h1>\n\n        <img class=\"abs halfScale 16-text\" style=\"top:581px;left:94px;\" src=\"/season2024-25/static/_content/16-pop-3-text-5.png\"/>\n        <img class=\"abs halfScale 16-bar\" style=\"top:615px;left:94px;\" src=\"/season2024-25/static/_content/16-pop-3-bar-5.png\"/>\n        <img class=\"abs halfScaleC 16-line-dotted\" style=\"top:545px;left:674px;\" src=\"/season2024-25/static/_content/16-pop-3-industry-line.png\"/>\n        <img class=\"abs halfScaleC 16-line\" style=\"top:539px;left:967px;\" src=\"/season2024-25/static/_content/16-pop-3-formulae-line.png\"/>\n        <h1 id=\"16-no\" class=\"abs feSans-miniBd 16-no\" style=\"top:575px;left:705px; font-size: 1.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 57,\"append\": \"%\"}' ></h1>\n        <h1 id=\"16-no\" class=\"abs feSans-miniBd 16-no\" style=\"top:570px;left:995px; font-size: 1.8em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 85,\"append\": \"%\"}' ></h1>\n        \n        <img class=\"abs halfScale 16-key\" style=\"top:712px;left:106px;\" src=\"/season2024-25/static/_content/16-pop-3-key-1.png\"/>\n        <img class=\"abs halfScale 16-key\" style=\"top:712px;left:305px;\" src=\"/season2024-25/static/_content/16-pop-3-key-2.png\"/>\n      </div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function showSixteenPopOne() {\n          showOverlay('16-pop-1')\n        }\n\n        function closeSixteenPopOne() {\n          hideOverlay('16-pop-1')\n        }\n\n        function showSixteenPopTwo() {\n          showOverlay('16-pop-2');\n          pg16Anim = new TimelineMax();\n          pg16Anim.fromTo(cOf(\"16-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[0])}}, 1.0)\n          .fromTo(cOf(\"16-perc\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2)\n          .fromTo(cOf(\"16-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[1])}}, 1.5)\n          .fromTo(cOf(\"16-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[2])}}, 1.6)\n          .fromTo(cOf(\"16-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[3])}}, 1.7);\n        }\n\n        function closeSixteenPopTwo() {\n          hideOverlay('16-pop-2')\n          resetNumbers(\"16-no\");\n        }\n\n        function showSixteenPopThree() {\n          showOverlay('16-pop-3');\n          pg16Anim = new TimelineMax();\n          pg16Anim.staggerFromTo(cOf(\"16-text\"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 1)\n          .staggerFromTo(cOf(\"16-bar\"), 0.3, {scaleX: 0}, {scaleX:0.5, ease: Power2.easeOut}, 0.1, 1.2)\n          .staggerFromTo(cOf(\"16-line-dotted\"), 0.6, {opacity:0, y: -25}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.1, 1.4)\n          .staggerFromTo(cOf(\"16-line\"), 0.6, {opacity:0, y: -25}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.1, 1.5)\n          .fromTo(cOf(\"16-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[4])}}, 1.7)\n          .fromTo(cOf(\"16-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[5])}}, 1.8)\n          .fromTo(cOf(\"16-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[6])}}, 1.9)\n          .fromTo(cOf(\"16-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[7])}}, 2.0)\n          .fromTo(cOf(\"16-no\")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[8])}}, 2.1)\n          .fromTo(cOf(\"16-no\")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[9])}}, 2.2)\n          .fromTo(cOf(\"16-no\")[10], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[10])}}, 2.3)\n          .fromTo(cOf(\"16-no\")[11], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[11])}}, 2.4)\n          .fromTo(cOf(\"16-no\")[12], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[12])}}, 2.5)\n          .fromTo(cOf(\"16-no\")[13], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"16-no\")[13])}}, 2.6)\n          .staggerFromTo(cOf(\"16-key\"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 2.8);\n        }\n\n        function closeSixteenPopThree() {\n          hideOverlay('16-pop-3')\n          resetNumbers(\"16-no\");\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop();\n          resetNumbers(\"16-no\");\n          closeSixteenPopOne();\n          closeSixteenPopTwo();\n          closeSixteenPopThree();\n          removeContentLinks()\n        }\n      ",
    "searchText": "MAINTAINING OUR LEADERSHIP POSITION For the fourth consecutive year, Formula E was ranked as the world's most sustainable sport by the Global Sustainability Benchmark in Sport (GSBS).  1  ST  OVERALL  for the fourth consecutive year  CLICK TO READ MORE  The independent assessment awarded Formula E the highest overall score across all participating organisations, recognising the continued progress made across environmental, social, governance and corporate performance.  CLICK TO READ MORE  CLICK TO SEE FORMULA E VS INDUSTRY AVERAGE  “  Formula E continues to lead the way in one of the most competitive global industries - now for the fourth consecutive year. Every year, when we review their data, it becomes clear that they have already moved ahead, continually advancing their practices and strengthening their approach to sustainability.” Christian Hartmann, CEO, Global Sustainability Benchmark in Sports (GSBS)  16  FORMULA EXCELLENCE  2024/25 SEASON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:406px; left:1159px; width:84px; height:86px;\"></div>     \n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg17Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg17Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "3 FORMULA FORMULA FORMULA FORMULA  EQUITY"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg18Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "TRIPLING OUR SOCIAL IMPACT IN THE 2024/25 SEASON Our eleventh season marked our most impactful year yet. Guided by a new Theory of Change, we strengthened the alignment between our social impact programmes, expanded our reach and deepened our contribution to communities around the world.  in local community projects, we continued to use Formula E as a platform for positive change.  THIS SECTION OF THE REPORT  BRINGING COMMUNITIES INTO THE RACE  A POSITIVE LEGACY IN HOST COMMUNITIES Better Futures Fund evolves into a Championship-wide programme. EXTENDING THE REACH OF FIA GIRLS ON TRACK Offering opportunities to more young women. INSPIRING THE NEXT GENERATION OF CHANGEMAKERS Driving Force connects electric racing with real-world challenges.  Across our four flagship programmes, we positively impacted 86,007 people – more than triple the total reached in the 2023/24 Season. From empowering young changemakers and increasing opportunities in motorsport to investing  COMMUNITY BENEFITS AND OPPORTUNITIES More than 3,500 people participate in race engagement activities. A MORE INCLUSIVE WORKFORCE Bringing our people and social impact programmes under a single framework.  18  FORMULA EQUITY  2024/25 SEASON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n      \n      <h1 id=\"19-no\" class=\"abs feSans-miniBd 19-no\" style=\"top:40px;left:471px; font-size: 8.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 86007, \"comma\" : true}' ></h1>\n      <img class=\"abs halfScale 19-block\" style=\"top:40px;left:1054px;\" src=\"/season2024-25/static/_content/19-block-1.png\"/>\n\n      <img class=\"abs halfScale 19-plus\" style=\"top:358px;left:674px;\" src=\"/season2024-25/static/_content/plus.png\"/>\n      <h1 id=\"19-no\" class=\"abs feSans-miniBd 19-no\" style=\"top:274px;left:733px; font-size: 8.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 241}' ></h1>\n      <img class=\"abs halfScale 19-perc\" style=\"top:325px;left:1026px;\" src=\"/season2024-25/static/_content/percentage.png\"/>\n      <img class=\"abs halfScale 19-block\" style=\"top:325px;left:1122px;\" src=\"/season2024-25/static/_content/19-block-2.png\"/>\n\n      <h1 id=\"19-no\" class=\"abs feSans-miniBd 19-no\" style=\"top:560px;left:379px; font-size: 8.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 960}' ></h1>\n      <img class=\"abs halfScale 19-block\" style=\"top:550px;left:707px;\" src=\"/season2024-25/static/_content/19-block-3.png\"/>\n\n      <h1 id=\"19-no\" class=\"abs feSans-miniBd 19-no\" style=\"top:534px;left:849px; font-size: 8.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 97}' ></h1>\n      <img class=\"abs halfScale 19-block\" style=\"top:485px;left:1039px;\" src=\"/season2024-25/static/_content/19-block-4.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg19Anim = new TimelineMax();\n          pg19Anim.fromTo(cOf(\"19-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"19-no\")[0])}}, 1)\n          .fromTo(cOf(\"19-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"19-no\")[1])}}, 1.1)\n          .fromTo(cOf(\"19-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"19-no\")[2])}}, 1.2)\n          .fromTo(cOf(\"19-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"19-no\")[3])}}, 1.3);\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg19Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "FORMULA FORMULA FORMULA FORMULA  86,007  EQUITY S_11  IN NUMBERS IN NUMBERS  PEOPLE POSITIVELY IMPACTED  +241  IN NUMBERS  %  GROWTH COMPARED WITH 2023/24 SEASON  97 960 IN NUMBERS  LOCAL COMMUNITY PARTNERS ENGAGED  19  FORMULA EQUITY  2024/25 SEASON  PROGRAMME ACTIVATIONS DELIVERED"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n      \n      <h1 id=\"20-no\" class=\"abs feSans-miniBd 20-no\" style=\"top:185px;left:860px; font-size: 3.4em; font-weight: 300; color: #00ff0a; padding: 0px; margin: 0px;\"  data-number='{\"to\": 250000, \"preppend\": \"\u20AC\", \"comma\" : true}' ></h1>\n      <h1 id=\"20-no\" class=\"abs feSans-miniBd 20-no\" style=\"top:289px;left:956px; font-size: 3.4em; font-weight: 300; color: #00ff0a; padding: 0px; margin: 0px;\"  data-number='{\"to\": 8847, \"comma\": true}' ></h1>\n      <h1 id=\"20-no\" class=\"abs feSans-miniBd 20-no\" style=\"top:418px;left:966px; font-size: 3.4em; font-weight: 300; color: #00ff0a; padding: 0px; margin: 0px;\"  data-number='{\"to\": 297}' ></h1>\n      <h1 id=\"20-no\" class=\"abs feSans-miniBd 20-no\" style=\"top:543px;left:968px; font-size: 3.4em; font-weight: 300; color: #00ff0a; padding: 0px; margin: 0px;\"  data-number='{\"to\": 11}' ></h1>\n\n      <!-- pop one -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 20-click-1\" style=\"top:408px;left:-91px;\" onclick=\"showTwentyPopOne()\" src=\"/season2024-25/static/_content/20-click-1.png\"/>\n      <div id=\"20-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 20-pop-1\" style=\"top:415px;left:32px;\" src=\"/season2024-25/static/_content/20-pop-1.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:430px;left:48px;width:285px;height:43px;\" onclick=\"hideOverlay('20-pop-1')\"></div>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:691px;left:761px;width:43px;height:43px;\" onclick=\"hideOverlay('20-pop-1')\"></div>\n      </div>\n\n      <!-- pop two -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 20-click-2\" style=\"top:465px;left:-115px;\" onclick=\"showTwentyPopTwo()\" src=\"/season2024-25/static/_content/20-click-2.png\"/>\n      <div id=\"20-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 20-pop-2\" style=\"top:68px;left:52px;\" src=\"/season2024-25/static/_content/20-pop-2.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:86px;left:1157px;width:43px;height:43px;\" onclick=\"hideOverlay('20-pop-2')\"></div>\n\n        <!-- city clicks -->\n        <img class=\"abs halfScale halfpulse animatedpulse pointer 20-click-pop\" style=\"top:512px;left:267px;\" onclick=\"openPop('20-cities', '20-city-1')\" src=\"/season2024-25/static/_content/20-pop-2-city-1.png\"/>\n\n        <img class=\"abs halfScale halfpulse animatedpulse pointer 20-click-pop\" style=\"top:372px;left:327px;\" onclick=\"openPop('20-cities', '20-city-2')\" src=\"/season2024-25/static/_content/20-pop-2-city-2.png\"/>\n\n        <img class=\"abs halfScale halfpulse animatedpulse pointer 20-click-pop\" style=\"top:452px;left:417px;\" onclick=\"openPop('20-cities', '20-city-3')\" src=\"/season2024-25/static/_content/20-pop-2-city-3.png\"/>\n\n        <img class=\"abs halfScale halfpulse animatedpulse pointer 20-click-pop\" style=\"top:430px;left:577px;\" onclick=\"openPop('20-cities', '20-city-4')\" src=\"/season2024-25/static/_content/20-pop-2-city-4.png\"/>\n\n        <img class=\"abs halfScale halfpulse animatedpulse pointer 20-click-pop\" style=\"top:231px;left:555px;\" onclick=\"openPop('20-cities', '20-city-5')\" src=\"/season2024-25/static/_content/20-pop-2-city-5.png\"/>\n\n        <img class=\"abs halfScale halfpulse animatedpulse pointer 20-click-pop\" style=\"top:268px;left:597px;\" onclick=\"openPop('20-cities', '20-city-6')\" src=\"/season2024-25/static/_content/20-pop-2-city-6.png\"/>\n\n        <img class=\"abs halfScale halfpulse animatedpulse pointer 20-click-pop\" style=\"top:362px;left:674px;\" onclick=\"openPop('20-cities', '20-city-7')\" src=\"/season2024-25/static/_content/20-pop-2-city-7.png\"/>\n\n        <img class=\"abs halfScale halfpulse animatedpulse pointer 20-click-pop\" style=\"top:589px;left:871px;\" onclick=\"openPop('20-cities', '20-city-8')\" src=\"/season2024-25/static/_content/20-pop-2-city-8.png\"/>\n\n        <img class=\"abs halfScale halfpulse animatedpulse pointer 20-click-pop\" style=\"top:292px;left:913px;\" onclick=\"openPop('20-cities', '20-city-9')\" src=\"/season2024-25/static/_content/20-pop-2-city-9.png\"/>\n\n        <img class=\"abs halfScale halfpulse animatedpulse pointer 20-click-pop\" style=\"top:342px;left:965px;\" onclick=\"openPop('20-cities', '20-city-10')\" src=\"/season2024-25/static/_content/20-pop-2-city-10.png\"/>\n\n        <!-- city pop -->\n        <div id=\"20-city-1\" class=\"20-cities hidden noclick\">\n          <img class=\"abs halfScale 20-pop-2-city-1\" style=\"top:67px;left:51px;\" src=\"/season2024-25/static/_content/20-pop-2-city-1-pop.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:92px;left:1150px;width:41px;height:42px;\" onclick=\"closePop('20-city-1')\"></div>\n        </div>\n\n        <div id=\"20-city-2\" class=\"20-cities hidden noclick\">\n          <img class=\"abs halfScale 20-pop-2-city-2\" style=\"top:67px;left:51px;\" src=\"/season2024-25/static/_content/20-pop-2-city-2-pop.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:92px;left:1150px;width:41px;height:42px;\" onclick=\"closePop('20-city-2')\"></div>\n        </div>\n\n        <div id=\"20-city-3\" class=\"20-cities hidden noclick\">\n          <img class=\"abs halfScale 20-pop-2-city-3\" style=\"top:67px;left:51px;\" src=\"/season2024-25/static/_content/20-pop-2-city-3-pop.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:92px;left:1150px;width:41px;height:42px;\" onclick=\"closePop('20-city-3')\"></div>\n        </div>\n\n        <div id=\"20-city-4\" class=\"20-cities hidden noclick\">\n          <img class=\"abs halfScale 20-pop-2-city-4\" style=\"top:67px;left:51px;\" src=\"/season2024-25/static/_content/20-pop-2-city-4-pop.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:92px;left:1150px;width:41px;height:42px;\" onclick=\"closePop('20-city-4')\"></div>\n        </div>\n\n        <div id=\"20-city-5\" class=\"20-cities hidden noclick\">\n          <img class=\"abs halfScale 20-pop-2-city-5\" style=\"top:67px;left:51px;\" src=\"/season2024-25/static/_content/20-pop-2-city-5-pop.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:92px;left:1150px;width:41px;height:42px;\" onclick=\"closePop('20-city-5')\"></div>\n        </div>\n\n        <div id=\"20-city-6\" class=\"20-cities hidden noclick\">\n          <img class=\"abs halfScale 20-pop-2-city-6\" style=\"top:67px;left:51px;\" src=\"/season2024-25/static/_content/20-pop-2-city-6-pop.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:92px;left:1150px;width:41px;height:42px;\" onclick=\"closePop('20-city-6')\"></div>\n        </div>\n\n        <div id=\"20-city-7\" class=\"20-cities hidden noclick\">\n          <img class=\"abs halfScale 20-pop-2-city-7\" style=\"top:67px;left:51px;\" src=\"/season2024-25/static/_content/20-pop-2-city-7-pop.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:92px;left:1150px;width:41px;height:42px;\" onclick=\"closePop('20-city-7')\"></div>\n        </div>\n\n        <div id=\"20-city-8\" class=\"20-cities hidden noclick\">\n          <img class=\"abs halfScale 20-pop-2-city-8\" style=\"top:67px;left:51px;\" src=\"/season2024-25/static/_content/20-pop-2-city-8-pop.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:92px;left:1150px;width:41px;height:42px;\" onclick=\"closePop('20-city-8')\"></div>\n        </div>\n\n        <div id=\"20-city-9\" class=\"20-cities hidden noclick\">\n          <img class=\"abs halfScale 20-pop-2-city-9\" style=\"top:67px;left:51px;\" src=\"/season2024-25/static/_content/20-pop-2-city-9-pop.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:92px;left:1150px;width:41px;height:42px;\" onclick=\"closePop('20-city-9')\"></div>\n        </div>\n\n        <div id=\"20-city-10\" class=\"20-cities hidden noclick\">\n          <img class=\"abs halfScale 20-pop-2-city-10\" style=\"top:67px;left:51px;\" src=\"/season2024-25/static/_content/20-pop-2-city-10-pop.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:92px;left:1150px;width:41px;height:42px;\" onclick=\"closePop('20-city-10')\"></div>\n        </div>\n      </div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim.fromTo(cOf(\"20-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"20-no\")[0])}}, 1.0)\n          .fromTo(cOf(\"20-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"20-no\")[1])}}, 1.0)\n          .fromTo(cOf(\"20-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"20-no\")[2])}}, 1.0)\n          .fromTo(cOf(\"20-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"20-no\")[3])}}, 1.0);\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function showTwentyPopOne() {\n          showOverlay('20-pop-1')\n        }\n\n        function closeTwentyPopOne() {\n          hideOverlay('20-pop-1')\n        }\n\n        function openPop(klass, id) {\n        popups = cOf(klass);\n        ele = idOf(id);\n        for(var i=0; i<popups.length; i++) {\n          popups[i].className = \"20-cities hidden noclick\";\n          }\n          ele.className = 'visible'\n        }\n\n        function closePop(id) {\n          ele = idOf(id);\n        ele.className = '20-cities hidden noclick'\n        }\n\n        function showTwentyPopTwo() {\n          showOverlay('20-pop-2')\n        }\n\n        function closeTwentyPopTwo() {\n          hideOverlay('20-pop-2')\n        }\n\n        function onPageLeave() {\n          pg20Anim.stop();\n          resetNumbers(\"20-no\");\n          closeTwentyPopOne();\n          closeTwentyPopTwo();\n          removeContentLinks()\n        }\n      ",
    "searchText": "A POSITIVE LEGACY IN HOST COMMUNITIES Introduced in the 2023/24 Season, the Better Futures Fund was created to ensure Formula E leaves a positive legacy in the communities that host our races. By supporting local organisations addressing social and environmental challenges, the fund extends our impact beyond race week and helps create lasting benefits in host cities.  €250,000 invested across 10 host cities  8,847  people impacted through funded projects  297  CLICK TO READ MORE  people engaged through race-week activities  CLICK TO READ OUR SEASON 11 HIGHLIGHTS  11  local organisations supported  20  FORMULA EQUITY  2024/25 SEASON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n\n      <!-- pop one -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 21-click-1\" style=\"top:416px;left:-92px;\" onclick=\"showTwentyOnePopOne()\" src=\"/season2024-25/static/_content/21-click-1.png\"/>\n      <div id=\"21-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 21-pop-1\" style=\"top:424px;left:36px;\" src=\"/season2024-25/static/_content/21-pop-1.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:440px;left:52px;width:285px;height:43px;\" onclick=\"hideOverlay('21-pop-1')\"></div>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:731px;left:1183px;width:43px;height:43px;\" onclick=\"hideOverlay('21-pop-1')\"></div>\n      </div>\n      \n      <!-- pop two -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 21-click-2\" style=\"top:683px;left:796px;\" onclick=\"showTwentyOnePopTwo()\" src=\"/season2024-25/static/_content/21-click-2.png\"/>\n      <div id=\"21-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 21-pop-2\" style=\"top:58px;left:44px;\" src=\"/season2024-25/static/_content/21-pop-2.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:725px;left:1136px;width:43px;height:43px;\" onclick=\"hideOverlay('21-pop-2')\"></div>\n      </div>\n      <img class=\"abs halfScale 21-image\" style=\"top:663px;left:1099px;\" src=\"/season2024-25/static/_content/21-image-1.png\"/>\n     \n      <!-- pop three -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 21-click-3\" style=\"top:446px;left:-92px;\" onclick=\"showTwentyOnePopThree()\" src=\"/season2024-25/static/_content/21-click-3.png\"/>\n      <div id=\"21-pop-3\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 21-pop-3\" style=\"top:52px;left:44px;\" src=\"/season2024-25/static/_content/21-pop-3.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:725px;left:1136px;width:43px;height:43px;\" onclick=\"hideOverlay('21-pop-3')\"></div>\n\n        <!-- animations -->\n        <h1 id=\"21-no\" class=\"abs feSans-miniBd 21-no\" style=\"top:569px;left:63px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1272, \"comma\": true}' ></h1>\n        <h1 id=\"21-no\" class=\"abs feSans-miniBd 21-no\" style=\"top:335px;left:492px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;\"  data-number='{\"to\": 97, \"append\": \"%\"}' ></h1>\n        <h1 id=\"21-no\" class=\"abs feSans-miniBd 21-no\" style=\"top:335px;left:871px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;\"  data-number='{\"to\": 6}' ></h1>\n        <h1 id=\"21-no\" class=\"abs feSans-miniBd 21-no\" style=\"top:482px;left:492px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;\"  data-number='{\"to\": 50, \"append\": \"%\"}' ></h1>\n        <h1 id=\"21-no\" class=\"abs feSans-miniBd 21-no\" style=\"top:482px;left:871px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;\"  data-number='{\"to\": 10}' ></h1>\n        <h1 id=\"21-no\" class=\"abs feSans-miniBd 21-no\" style=\"top:627px;left:492px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;\"  data-number='{\"to\": 38, \"append\": \"%\"}' ></h1>\n        <h1 id=\"21-no\" class=\"abs feSans-miniBd 21-no\" style=\"top:627px;left:868px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;\"  data-number='{\"to\": 5900, \"append\": \"+\", \"comma\": true}' ></h1>\n      </div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>  \n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function showTwentyOnePopOne() {\n          showOverlay('21-pop-1')\n        }\n\n        function closeTwentyOnePopOne() {\n          hideOverlay('21-pop-1')\n        }\n\n        function showTwentyOnePopTwo() {\n          showOverlay('21-pop-2')\n        }\n\n        function closeTwentyOnePopTwo() {\n          hideOverlay('21-pop-2')\n        }\n\n        function showTwentyOnePopThree() {\n          showOverlay('21-pop-3');\n          pg21Anim = new TimelineMax();\n          pg21Anim.fromTo(cOf(\"21-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[0])}}, 1.0)\n          .fromTo(cOf(\"21-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[1])}}, 1.1)\n          .fromTo(cOf(\"21-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[2])}}, 1.1)\n          .fromTo(cOf(\"21-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[3])}}, 1.1)\n          .fromTo(cOf(\"21-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[4])}}, 1.1)\n          .fromTo(cOf(\"21-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[5])}}, 1.1)\n          .fromTo(cOf(\"21-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[6])}}, 1.1);\n        }\n\n        function closeTwentyOnePopThree() {\n          hideOverlay('21-pop-3')\n          resetNumbers(\"21-no\");\n        }\n\n        function onPageLeave() {\n          pg21Anim.stop();\n          resetNumbers(\"21-no\");\n          closeTwentyOnePopOne();\n          closeTwentyOnePopTwo();\n          closeTwentyOnePopThree();\n          removeContentLinks()\n        }\n      ",
    "searchText": "CREATING OPPORTUNITIES WITH FIA GIRLS ON TRACK Since its launch in 2016, FIA Girls on Track has become one of Formula E's flagship social impact programmes, creating opportunities for young women to explore careers in motorsport and STEM.  CLICK TO READ MORE  1,272 young women engaged across all race markets  CLICK TO SEE MORE NUMBERS  21  FORMULA EQUITY  CLICK TO READ ANNA’S STORY  2024/25 SEASON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n\n      <!-- pop one -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 22-click-1\" style=\"top:366px;left:-90px;\" onclick=\"showTwentyTwoPopOne()\" src=\"/season2024-25/static/_content/22-click-1.png\"/>\n      <div id=\"22-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 22-pop-1\" style=\"top:372px;left:36px;\" src=\"/season2024-25/static/_content/22-pop-1.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:386px;left:52px;width:285px;height:43px;\" onclick=\"hideOverlay('22-pop-1')\"></div>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:726px;left:1121px;width:43px;height:43px;\" onclick=\"hideOverlay('22-pop-1')\"></div>\n      </div>\n      \n      <!-- pop two -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 22-click-2\" style=\"top:630px;left:-119px;\" onclick=\"showTwentyTwoPopTwo()\" src=\"/season2024-25/static/_content/22-click-2.png\"/>\n      <div id=\"22-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 22-pop-2\" style=\"top:162px;left:45px;\" src=\"/season2024-25/static/_content/22-pop-2.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:187px;left:1144px;width:43px;height:43px;\" onclick=\"hideOverlay('22-pop-2')\"></div>\n\n        <!-- animations -->\n        <h1 id=\"22-no\" class=\"abs feSans-miniBd 22-no\" style=\"top:619px;left:258px; font-size: 3.7em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;\"  data-number='{\"to\": 236000, \"comma\" : true}' ></h1>\n        <h1 id=\"22-no\" class=\"abs feSans-miniBd 22-no\" style=\"top:254px;left:76px; font-size: 3.4em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;\"  data-number='{\"to\": 187, \"preppend\" : \"\u20AC\", \"append\" : \"M\"}' ></h1>\n        <h1 id=\"22-no\" class=\"abs feSans-miniBd 22-no\" style=\"top:255px;left:419px; font-size: 3.4em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;\"  data-number='{\"to\": 159, \"preppend\" : \"\u20AC\", \"append\" : \"M\"}' ></h1>\n        <h1 id=\"22-no\" class=\"abs feSans-miniBd 22-no\" style=\"top:255px;left:831px; font-size: 3.4em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;\"  data-number='{\"to\": 4300, \"comma\" : true}' ></h1>\n        <h1 id=\"22-no\" class=\"abs feSans-miniBd 22-no\" style=\"top:389px;left:832px; font-size: 3.4em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;\"  data-number='{\"to\": 680}' ></h1>\n        <h1 id=\"22-no\" class=\"abs feSans-miniBd 22-no\" style=\"top:510px;left:831px; font-size: 3.4em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;\"  data-number='{\"to\": 5.6, \"preppend\" : \"\u20AC\", \"append\" : \"M\", \"decimals\" : 1}' ></h1>\n        <h1 id=\"22-no\" class=\"abs feSans-miniBd 22-no\" style=\"top:631px;left:830px; font-size: 3.4em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;\"  data-number='{\"to\": 2.7, \"decimals\" : 1}' ></h1>\n      </div>\n\n      <!-- pop three -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 22-click-3\" style=\"top:703px;left:341px;\" onclick=\"showTwentyTwoPopThree()\" src=\"/season2024-25/static/_content/22-click-3.png\"/>\n      <div id=\"22-pop-3\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 22-pop-3\" style=\"top:302px;left:412px;\" src=\"/season2024-25/static/_content/22-pop-3.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:364px;left:604px;width:43px;height:43px;\" onclick=\"hideOverlay('22-pop-3')\"></div>\n      </div>\n\n      <!-- pop four -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 22-click-4\" style=\"top:703px;left:769px;\" onclick=\"showTwentyTwoPopFour()\" src=\"/season2024-25/static/_content/22-click-4.png\"/>\n      <div id=\"22-pop-4\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 22-pop-4\" style=\"top:302px;left:835px;\" src=\"/season2024-25/static/_content/22-pop-4.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:364px;left:1028px;width:43px;height:43px;\" onclick=\"hideOverlay('22-pop-4')\"></div>\n      </div>\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>   \n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function showTwentyTwoPopOne() {\n          showOverlay('22-pop-1')\n        }\n\n        function closeTwentyTwoPopOne() {\n          hideOverlay('22-pop-1')\n        }\n\n        function showTwentyTwoPopTwo() {\n          showOverlay('22-pop-2');\n          pg22Anim = new TimelineMax();\n          pg22Anim.fromTo(cOf(\"22-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"22-no\")[0])}}, 1.0)\n          .fromTo(cOf(\"22-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"22-no\")[1])}}, 1.1)\n          .fromTo(cOf(\"22-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"22-no\")[2])}}, 1.2)\n          .fromTo(cOf(\"22-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"22-no\")[3])}}, 1.3)\n          .fromTo(cOf(\"22-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"22-no\")[4])}}, 1.4)\n          .fromTo(cOf(\"22-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"22-no\")[5])}}, 1.5)\n          .fromTo(cOf(\"22-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"22-no\")[6])}}, 1.6);\n        }\n\n        function closeTwentyTwoPopTwo() {\n          hideOverlay('22-pop-2')\n          resetNumbers(\"22-no\");\n        }\n          \n        function showTwentyTwoPopThree() {\n          showOverlay('22-pop-3')\n        }\n\n        function closeTwentyTwoPopThree() {\n          hideOverlay('22-pop-3')\n        }\n\n        function showTwentyTwoPopFour() {\n          showOverlay('22-pop-4')\n        }\n\n        function closeTwentyTwoPopFour() {\n          hideOverlay('22-pop-4')\n        }\n\n        function onPageLeave() {\n          pg22Anim.stop();\n          resetNumbers(\"22-no\");\n          closeTwentyTwoPopOne();\n          closeTwentyTwoPopTwo();\n          closeTwentyTwoPopThree();\n          closeTwentyTwoPopFour();\n          removeContentLinks()\n        }\n      ",
    "searchText": "DELIVERING SOCIAL AND ECONOMIC IMPACT Formula E exists to accelerate sustainable human progress. But understanding whether that progress is being achieved requires robust evidence, consistent measurement and a clear view of the outcomes created through our Theory of Change.  IMPACT METHODOLOGY CLICK TO TAB BELOW TO READ MORE  CLICK TO READ MORE  2024/25 SEASON SOCIO-ECONOMIC IMPACT CLICK TO READ MORE  22  FORMULA EQUITY  SOCIAL  2024/25 SEASON  ECONOMIC"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n\n      <h1 id=\"23-no\" class=\"abs feSans-miniBd 23-no\" style=\"top:51px;left:960px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 3503, \"comma\" : true}' ></h1>\n      <h1 id=\"23-no\" class=\"abs feSans-miniBd 23-no\" style=\"top:177px;left:959px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\":5900, \"comma\": true, \"append\" : \"+\"}' ></h1>\n      <h1 id=\"23-no\" class=\"abs feSans-miniBd 23-no\" style=\"top:302px;left:960px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 4}' ></h1>\n      <h1 id=\"23-no\" class=\"abs feSans-miniBd 23-no\" style=\"top:425px;left:961px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 450}' ></h1>\n      \n      <!-- pop one -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 23-click-1\" style=\"top:596px;left:-90px;\" onclick=\"showTwentyThreePopOne()\" src=\"/season2024-25/static/_content/23-click-1.png\"/>\n      <div id=\"23-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 23-pop-1\" style=\"top:329px;left:36px;\" src=\"/season2024-25/static/_content/23-pop-1.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:616px;left:52px;width:285px;height:43px;\" onclick=\"hideOverlay('23-pop-1')\"></div>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:345px;left:717px;width:43px;height:43px;\" onclick=\"hideOverlay('23-pop-1')\"></div>\n      </div>\n\n      <!-- pop two -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 23-click-2\" style=\"top:571px;left:609px;\" onclick=\"showTwentyThreePopTwo()\" src=\"/season2024-25/static/_content/23-click-2.png\"/>\n      <div id=\"23-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 23-pop-2\" style=\"top:68px;left:46px;\" src=\"/season2024-25/static/_content/23-pop-2.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:717px;left:67px;width:43px;height:43px;\" onclick=\"hideOverlay('23-pop-2')\"></div>\n      </div>\n      \n      <!-- pop three -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 23-click-3\" style=\"top:667px;left:609px;\" onclick=\"showTwentyThreePopThree()\" src=\"/season2024-25/static/_content/23-click-3.png\"/>\n      <div id=\"23-pop-3\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 23-pop-3\" style=\"top:68px;left:46px;\" src=\"/season2024-25/static/_content/23-pop-3.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:717px;left:67px;width:43px;height:43px;\" onclick=\"hideOverlay('23-pop-3')\"></div>\n      </div>\n \n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>  \n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg23Anim = new TimelineMax();\n          pg23Anim.fromTo(cOf(\"23-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"23-no\")[0])}}, 1.0)\n          .fromTo(cOf(\"23-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"23-no\")[1])}}, 1.0)\n          .fromTo(cOf(\"23-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"23-no\")[2])}}, 1.0)\n          .fromTo(cOf(\"23-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"23-no\")[3])}}, 1.0);\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function showTwentyThreePopOne() {\n          showOverlay('23-pop-1')\n        }\n\n        function closeTwentyThreePopOne() {\n          hideOverlay('23-pop-1')\n        }\n\n        function showTwentyThreePopTwo() {\n          showOverlay('23-pop-2')\n        }\n\n        function closeTwentyThreePopTwo() {\n          hideOverlay('23-pop-2')\n        }\n\n        function showTwentyThreePopThree() {\n          showOverlay('23-pop-3')\n        }\n\n        function closeTwentyThreePopThree() {\n          hideOverlay('23-pop-3')\n        }\n\n        function onPageLeave() {\n          pg23Anim.stop();\n          resetNumbers(\"23-no\");\n          closeTwentyThreePopOne();\n          closeTwentyThreePopTwo();\n          closeTwentyThreePopThree();\n          removeContentLinks()\n        }\n      ",
    "searchText": "COMMUNITY BENEFITS AND OPPORTUNITIES Communities hosting our races should share in the excitement, opportunities and benefits created by the Championship, and throughout the 2024/25 Season, we continued to engage them through race-week activities, experiences and chances to attend Formula E events.  3,503  people engaged through community programmes  5,900+  complimentary race tickets distributed  4  cities expanded or enhanced Community Tours  A total of 3,503 people participated in community engagement activities globally, alongside nearly 6,000 complimentary race tickets were distributed to community groups, charities and local organisations, helping make Formula E accessible to a wider audience.  450  students engaged through Greater London Authority workshops  CLICK TO READ DIVERSITY IN MOTORSPORT FUND  CLICK TO READ MORE  CLICK TO READ SUPPORTING LOCAL RECOVERY IN VALENCIA  23  FORMULA EQUITY  2024/25 SEASON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n      \n      <!-- pop one -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 24-click-1\" style=\"top:531px;left:-90px;\" onclick=\"showTwentyFourPopOne()\" src=\"/season2024-25/static/_content/24-click-1.png\"/>\n      <div id=\"24-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 24-pop-1\" style=\"top:332px;left:35px;\" src=\"/season2024-25/static/_content/24-pop-1.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:551px;left:52px;width:285px;height:43px;\" onclick=\"hideOverlay('24-pop-1')\"></div>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:722px;left:717px;width:43px;height:43px;\" onclick=\"hideOverlay('24-pop-1')\"></div>\n      </div>\n\n      <!-- pop two -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 24-click-2\" style=\"top:583px;left:-151px;\" onclick=\"showTwentyFourPopTwo()\" src=\"/season2024-25/static/_content/24-click-2.png\"/>\n      <div id=\"24-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 24-pop-2\" style=\"top:68px;left:50px;\" src=\"/season2024-25/static/_content/24-pop-2.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:717px;left:75px;width:43px;height:43px;\" onclick=\"hideOverlay('24-pop-2')\"></div>\n      </div>\n      \n      <!-- pop three -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 24-click-3\" style=\"top:667px;left:-188px;\" onclick=\"showTwentyFourPopThree()\" src=\"/season2024-25/static/_content/24-click-3.png\"/>\n      <div id=\"24-pop-3\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 24-pop-3\" style=\"top:68px;left:52px;\" src=\"/season2024-25/static/_content/24-pop-3.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:717px;left:73px;width:43px;height:43px;\" onclick=\"hideOverlay('24-pop-3')\"></div>\n\n        <!-- animations -->\n        <h1 id=\"24-no\" class=\"abs feSans-miniBd 24-no\" style=\"top:399px;left:516px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 92}' ></h1>\n        <h1 id=\"24-no\" class=\"abs feSans-miniBd 24-no\" style=\"top:527px;left:516px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 15.5, \"decimals\" : 1}' ></h1>\n        <img class=\"abs halfScale 24-text\" style=\"top:658px;left:522px;\" src=\"/season2024-25/static/_content/24-pop-3-text.png\"/>\n      </div>\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>   \n  \n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function showTwentyFourPopOne() {\n          showOverlay('24-pop-1')\n        }\n\n        function closeTwentyFourPopOne() {\n          hideOverlay('24-pop-1')\n        }\n\n        function showTwentyFourPopTwo() {\n          showOverlay('24-pop-2')\n        }\n\n        function closeTwentyFourPopTwo() {\n          hideOverlay('24-pop-2')\n        }\n\n        function showTwentyFourPopThree() {\n          showOverlay('24-pop-3');\n          pg24Anim = new TimelineMax();\n          pg24Anim.fromTo(cOf(\"24-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"24-no\")[0])}}, 1.0)\n          .fromTo(cOf(\"24-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"24-no\")[1])}}, 1.2)\n          .fromTo(cOf(\"24-text\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.5);\n        }\n\n        function closeTwentyFourPopThree() {\n          hideOverlay('24-pop-3')\n          pg24Anim.stop();\n        }\n\n        function onPageLeave() {\n          pg24Anim.stop();\n          resetNumbers(\"24-no\");\n          closeTwentyFourPopOne();\n          closeTwentyFourPopTwo();\n          closeTwentyFourPopThree();\n          removeContentLinks()\n        }\n      ",
    "searchText": "A MORE INCLUSIVE WORKFORCE Creating a more inclusive motorsport industry starts with creating a more inclusive organisation, and, in the 2024/25 Season, we formally launched ‘Driving Change’, our Equity, Diversity and Inclusion Strategy for 2025-2027.  PROGRESS TOWARDS OUR STRATEGIC AMBITIONS FOR 2027 TARGET: 50% Female, 50% Male  54.9% female representation  Developed over three years, the strategy brings together our internal people agenda and external social impact programmes under a single framework, helping us create greater opportunities within Formula E while supporting wider change across motorsport.  TARGET: 82% White, 18% Black, Asian, Mixed & Other  19.9% Black, Asian and other ethnic minority representation  CLICK TO READ MORE  TARGET: 56% Professional Class, 20% Intermediate Class, 24% Working Class  CLICK TO READ CREATING PATHWAYS TO THE INDUSTRY  21.0%  CLICK TO READ GREATER FLEXIBILITY FOR EMPLOYEE VOLUNTEERING  24  FORMULA EQUITY  working-class representation  2024/25 SEASON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:406px; left:1159px; width:84px; height:86px;\"></div>    \n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg25Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "4 FORMULA FORMULA FORMULA FORMULA  ENVIRONMENT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n\n      <!-- pop one -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 26-click-1\" style=\"top:647px;left:729px;\" onclick=\"showTwentySixPopOne()\" src=\"/season2024-25/static/_content/26-click-1.png\"/>\n      <div id=\"26-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 26-pop-1\" style=\"top:68px;left:13px;\" src=\"/season2024-25/static/_content/26-pop-1.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:90px;left:1148px;width:43px;height:43px;\" onclick=\"hideOverlay('26-pop-1')\"></div>\n      </div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>   \n\n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function showTwentySixPopOne() {\n          showOverlay('26-pop-1')\n        }\n\n        function closeTwentySixPopOne() {\n          hideOverlay('26-pop-1')\n        }\n\n        function onPageLeave() {\n          closeTwentySixPopOne();\n          removeContentLinks()\n        }\n      ",
    "searchText": "BUILDING A PATHWAY TO SIGNIFICANT EMISSION REDUCTIONS The 2024/25 Season marked an important evolution in Formula E's environmental strategy. As expectations around climate accountability continue to evolve, we shifted our focus from carbon neutrality towards a certified Net Zero Pathway built on emissions reductions, enhanced carbon accounting and long-term planning.  OUR CARBON IMPACT Measurement and methodology of our 2024/25 Season carbon footprint. OUR REDUCTION EFFORTS Cutting our emissions against our baseline targets.  As a signatory of the UNFCCC Sports for Climate Action Framework, we are aligning our actions with the goals of the Paris Agreement and accelerating progress towards a low-carbon future. This chapter explores how Formula E is measuring emissions, reducing its environmental impact and building a credible pathway to net zero.  26  FORMULA ENVIRONMENT  THIS SECTION OF THE REPORT  NET ZERO IS OUR FINISH LINE  CLICK TO REVEAL OUR NET ZERO PATHWAY  2024/25 SEASON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n    \n      <h1 id=\"27-no\" class=\"abs feSans-miniBd 27-no\" style=\"top:38px;left:359px; font-size: 8.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 365}' ></h1>\n      <img class=\"abs halfScale 27-tco2e\" style=\"top:81px;left:710px;\" src=\"/season2024-25/static/_content/tco2e.png\"/>\n      <img class=\"abs halfScale 27-block\" style=\"top:38px;left:968px;\" src=\"/season2024-25/static/_content/27-block-1.png\"/>\n\n      <h1 id=\"27-no\" class=\"abs feSans-miniBd 27-no\" style=\"top:337px;left:691px; font-size: 8.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 18}' ></h1>\n      <img class=\"abs halfScale 27-perc\" style=\"top:380px;left:882px;\" src=\"/season2024-25/static/_content/percentage.png\"/>\n      <img class=\"abs halfScale 27-block\" style=\"top:380px;left:979px;\" src=\"/season2024-25/static/_content/27-block-1.png\"/>\n\n      <h1 id=\"27-no\" class=\"abs feSans-miniBd 27-no\" style=\"top:559px;left:351px; font-size: 8.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 2050}' ></h1>\n      <img class=\"abs halfScale 27-block\" style=\"top:602px;left:772px;\" src=\"/season2024-25/static/_content/27-block-1.png\"/>\n\n      <h1 id=\"27-no\" class=\"abs feSans-miniBd 27-no\" style=\"top:553px;left:849px; font-size: 8.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 28}' ></h1>\n      <img class=\"abs halfScale 27-perc\" style=\"top:592px;left:1073px;\" src=\"/season2024-25/static/_content/percentage.png\"/>\n      <img class=\"abs halfScale 27-block\" style=\"top:592px;left:1171px;\" src=\"/season2024-25/static/_content/27-block-1.png\"/>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg27Anim = new TimelineMax();\n          pg27Anim.fromTo(cOf(\"27-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"27-no\")[0])}}, 1.0)\n          pg27Anim.fromTo(cOf(\"27-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"27-no\")[1])}}, 1.1)\n          pg27Anim.fromTo(cOf(\"27-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"27-no\")[2])}}, 1.2)\n          pg27Anim.fromTo(cOf(\"27-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"27-no\")[3])}}, 1.3);\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg27Anim.stop();\n          resetNumbers(\"27-no\");\n          removeContentLinks()\n        }\n      ",
    "searchText": "FORMULA FORMULA FORMULA FORMULA  365  tCO₂e  REDUCTION IN AVERAGE RACE EMISSIONS COMPARED WITH THE 2023/24 SEASON  ENVIRONMENT S_11  18  %  IN NUMBERS IN NUMBERS IN NUMBERS  REDUCTION IN EMISSIONS COMPARED WITH OUR 2018 BASELINE  IN NUMBERS  2050 28  %  NET ZERO ACHIEVED BY THIS DATE AT THE LATEST  27  FORMULA ENVIRONMENT  2024/25 SEASON  REDUCTION IN FREIGHTRELATED CARBON EMISSIONS  (COMPARED WITH THE 2023/24 SEASON)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n\n      <!-- pop one -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 28-click-1\" style=\"top:373px;left:262px;\" onclick=\"showTwentyEightPopOne()\" src=\"/season2024-25/static/_content/28-click-1.png\"/>\n      <div id=\"28-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 28-pop-1\" style=\"top:68px;left:49px;\" src=\"/season2024-25/static/_content/28-pop-1.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:90px;left:1150px;width:43px;height:43px;\" onclick=\"hideOverlay('28-pop-1')\"></div>\n      </div>\n\n      <!-- pop two -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 28-click-2\" style=\"top:501px;left:262px;\" onclick=\"showTwentyEightPopTwo()\" src=\"/season2024-25/static/_content/28-click-2.png\"/>\n      <div id=\"28-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 28-pop-2\" style=\"top:68px;left:49px;\" src=\"/season2024-25/static/_content/28-pop-2.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:90px;left:1150px;width:43px;height:43px;\" onclick=\"hideOverlay('28-pop-2')\"></div>\n\n        <!-- animations -->\n        <h1 id=\"28-no\" class=\"abs feSans-midiBd 28-no\" style=\"top:206px;left:87px; font-size: 4.9em; font-weight: 300; color: #00005a; padding: 0px; margin: 0px;\"  data-number='{\"to\": 27186, \"comma\": true}' ></h1>\n        <h1 id=\"28-no\" class=\"abs feSans-midiBd 28-no\" style=\"top:344px;left:731px; font-size: 1.15em; font-weight: 300; color: #00005a; padding: 0px; margin: 0px;\"  data-number='{\"to\": 7.6, \"decimals\": 1, \"append\": \"%\"}' ></h1>\n        <h1 id=\"28-no\" class=\"abs feSans-midiBd 28-no\" style=\"top:368px;left:950px; font-size: 1.15em; font-weight: 300; color: #00005a; padding: 0px; margin: 0px;\"  data-number='{\"to\": 3, \"append\" : \"%\"}' ></h1>\n        <h1 id=\"28-no\" class=\"abs feSans-midiBd 28-no\" style=\"top:347px;left:1083px; font-size: 1.15em; font-weight: 300; color: #00005a; padding: 0px; margin: 0px;\"  data-number='{\"to\": 0.5, \"decimals\" : 1, \"append\" : \"%\"}' ></h1>\n        <h1 id=\"28-no\" class=\"abs feSans-midiBd 28-no\" style=\"top:570px;left:843px; font-size: 1.15em; font-weight: 300; color: #00005a; padding: 0px; margin: 0px;\"  data-number='{\"to\": 4.4, \"decimals\" : 1, \"append\" : \"%\"}' ></h1>\n        <h1 id=\"28-no\" class=\"abs feSans-midiBd 28-no\" style=\"top:569px;left:1020px; font-size: 1.15em; font-weight: 300; color: #00005a; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1.1, \"decimals\" : 1, \"append\": \"%\"}' ></h1>\n        <h1 id=\"28-no\" class=\"abs feSans-midiBd 28-no\" style=\"top:658px;left:547px; font-size: 1.15em; font-weight: 300; color: #00005a; padding: 0px; margin: 0px;\"  data-number='{\"to\": 31.8, \"decimals\" : 1, \"append\": \"%\"}' ></h1>\n        <h1 id=\"28-no\" class=\"abs feSans-midiBd 28-no\" style=\"top:709px;left:228px; font-size: 1.15em; font-weight: 300; color: #00005a; padding: 0px; margin: 0px;\"  data-number='{\"to\": 51.6, \"decimals\" : 1, \"append\": \"%\"}' ></h1>\n\n        <!-- click for popup-3 of popup-2 -->\n        <img class=\"abs halfScaleC halfpulse animatedpulse pointer 28-pop-2-click-1\" style=\"top:142px;left:666px;\" onclick=\"openPop('28-emissions-breakdown-race', '28-emissions-breakdown-race-1')\" src=\"/season2024-25/static/_content/28-pop-2-click-1.png\"/>\n\n        <a href=\"https://drive.google.com/file/d/1p5tyXBxIwdDGDBbJGI93Q0tAvZRuA6lb/view\" target=\"_blank\" class=\"contentLinkNone\">\n          <img class=\"abs halfScaleC halfpulse animatedpulse pointer 28-pop-2-click-2\" style=\"top:643px;left:666px;\" onclick=\"openPop('28-emissions-breakdown-race', '28-emissions-breakdown-race-2')\" src=\"/season2024-25/static/_content/28-pop-2-click-2.png\"/>\n        </a>\n\n        <!-- pop-up-3 -->\n        <div id=\"28-emissions-breakdown-race-1\" class=\"28-emissions-breakdown-race hidden noclick\">\n          <img class=\"abs halfScale 28-emissions-breakdown-race-1\" style=\"top:68px;left:49px;\" src=\"/season2024-25/static/_content/28-pop-2-pop-3.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:93px;left:1148px;width:41px;height:42px;\" onclick=\"closePop('28-emissions-breakdown-race-1')\"></div>\n        </div>\n\n        <!-- click for popup-3 of popup-2 -->\n\n      </div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function showTwentyEightPopOne() {\n          showOverlay('28-pop-1')\n        }\n\n        function closeTwentyEightPopOne() {\n          hideOverlay('28-pop-1')\n        }\n\n        function openPop(klass, id) {\n        popups = cOf(klass);\n        ele = idOf(id);\n        for(var i=0; i<popups.length; i++) {\n          popups[i].className = \"28-emissions-breakdown-race hidden noclick\";\n          }\n          ele.className = 'visible'\n        }\n\n        function closePop(id) {\n          ele = idOf(id);\n        ele.className = '28-emissions-breakdown-race hidden noclick'\n        }\n\n        function showTwentyEightPopTwo() {\n          showOverlay('28-pop-2');\n          pg28Anim = new TimelineMax();\n          pg28Anim.fromTo(cOf(\"28-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"28-no\")[0])}}, 1.0)\n          .fromTo(cOf(\"28-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"28-no\")[1])}}, 1.1)\n          .fromTo(cOf(\"28-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"28-no\")[2])}}, 1.1)\n          .fromTo(cOf(\"28-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"28-no\")[3])}}, 1.1)\n          .fromTo(cOf(\"28-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"28-no\")[4])}}, 1.1)\n          .fromTo(cOf(\"28-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"28-no\")[5])}}, 1.1)\n          .fromTo(cOf(\"28-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"28-no\")[6])}}, 1.1)\n          .fromTo(cOf(\"28-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"28-no\")[7])}}, 1.1);\n        }\n\n        function closeTwentyEightPopTwo() {\n          hideOverlay('28-pop-2')\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop();\n          resetNumbers(\"28-no\");\n          closeTwentyEightPopOne();\n          closeTwentyEightPopTwo();\n          removeContentLinks()\n        }\n      ",
    "searchText": "To ensure consistency and comparability over time, the 2024/25 Season emissions have been calculated using the same methodology applied to our baseline 2018/19 Season footprint and subsequent assessments in seasons 2022/23 and 2023/24. Emissions are calculated using the latest available emission factors and are reported across Scope 1, Scope 2 and Scope 3 categories. REPORTING BOUNDARY Formula E's carbon footprint assessment captures both direct and indirect greenhouse gas emissions generated across our operations and value chain.  CLICK TO READ HOW EMISSIONS ARE CALCULATED CLICK TO READ EMISSIONS BREAKDOWN  Direct emissions are those generated from sources owned or controlled by Formula E, including energy consumption at facilities, owned infrastructure and operational activities.  28  FORMULA ENVIRONMENT  2024/25 SEASON  SCOPE 1  Indirect emissions occur as a consequence of Formula E's activities but arise from sources not owned or controlled by the organisation. These include emissions associated with logistics, business travel, spectator travel, employee commuting, waste management and the race cars. Together, these emissions provide a comprehensive picture of Formula E's environmental impact across the championship lifecycle.  SCOPE 2  We measure our greenhouse gas (GHG) emissions using a methodology aligned with the Greenhouse Gas Protocol and ISO 14064-1.  SCOPE 3  OUR CARBON IMPACT  DIRECT EMISSIONS Direct emissions from sources owned or controlled by Formula E. Gas consumption at HQ Fuel consumed by generators at races (HVO and B100 biofuels)Fuel consumed by plant and machinery at races  INDIRECT ENERGY EMISSIONS Indirect emissions resulting from the generation of purchased energy. rid electricity consumed G at HQ and at races  OTHER INDIRECT EMISSIONS Indirect emissions generated throughout the value chain. Logistics Business travel Spectator travel Event catering Branding Employee commuting and homeworking Staff uniforms Race car production Waste generated Water consumed"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n      \n      <h1 id=\"29-no\" class=\"abs feSans-miniBd 29-no\" style=\"top:337px;left:780px; font-size: 3.3em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 18, \"append\" : \"%\"}' ></h1>\n      <h1 id=\"29-no\" class=\"abs feSans-miniBd 29-no\" style=\"top:381px;left:973px; font-size: 3.3em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 28, \"append\" : \"%\"}' ></h1>\n      <h1 id=\"29-no\" class=\"abs feSans-miniBd 29-no\" style=\"top:508px;left:1044px; font-size: 3.3em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 20, \"append\" : \"%\"}' ></h1>\n\n      <!-- pop one -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 29-click-1\" style=\"top:80px;left:902px;\" onclick=\"showTwentyNinePopOne()\" src=\"/season2024-25/static/_content/29-click-1.png\"/>\n      <div id=\"29-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 29-pop-1\" style=\"top:144px;left:733px;\" src=\"/season2024-25/static/_content/29-pop-1.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:692px;left:1155px;width:43px;height:43px;\" onclick=\"hideOverlay('29-pop-1')\"></div>\n\n        <div class=\"addContentLink\" style=\"top:603px;left:943px;width:178px;height:20px;\">\n          <a href=\"https://icvcm.org/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:624px;left:760px;width:378px;height:20px;\">\n          <a href=\"https://icvcm.org/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:645px;left:760px;width:184px;height:20px;\">\n          <a href=\"https://icvcm.org/\" target=\"_blank\"></a>\n        </div>\n      </div>\n\n      <!-- pop two -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 29-click-2\" style=\"top:664px;left:-117px;\" onclick=\"showTwentyNinePopTwo()\" src=\"/season2024-25/static/_content/29-click-2.png\"/>\n      <div id=\"29-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 29-pop-2\" style=\"top:68px;left:49px;\" src=\"/season2024-25/static/_content/29-pop-2.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:716px;left:73px;width:43px;height:43px;\" onclick=\"hideOverlay('29-pop-2')\"></div>\n\n        <!-- animations -->\n        <h1 id=\"29-no\" class=\"abs feSans-miniBd 29-no\" style=\"top:201px;left:825px; font-size: 3.3em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 261}' ></h1>\n        <h1 id=\"29-no\" class=\"abs feSans-miniMed 29-no\" style=\"top:218px;left:949px; font-size: 0.95em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 2, \"preppend\" :\"(\", \"append\" : \"%)\"}' ></h1>\n\n        <h1 id=\"29-no\" class=\"abs feSans-miniBd 29-no\" style=\"top:303px;left:864px; font-size: 3.3em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 13417, \"comma\" : true}' ></h1>\n        <h1 id=\"29-no\" class=\"abs feSans-miniMed 29-no\" style=\"top:318px;left:1069px; font-size: 0.95em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 96, \"preppend\" :\"(\", \"append\" : \"%)\"}' ></h1>\n\n        <h1 id=\"29-no\" class=\"abs feSans-miniBd 29-no\" style=\"top:401px;left:795px; font-size: 3.3em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 440}' ></h1>\n        <h1 id=\"29-no\" class=\"abs feSans-miniMed 29-no\" style=\"top:415px;left:929px; font-size: 0.95em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 2, \"preppend\" :\"(\", \"append\" : \"%)\"}' ></h1>\n      </div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg29Anim = new TimelineMax();\n          pg29Anim.fromTo(cOf(\"29-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[0])}}, 1.0)\n          .fromTo(cOf(\"29-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[1])}}, 1.1)\n          .fromTo(cOf(\"29-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[2])}}, 1.2);\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function showTwentyNinePopOne() {\n          showOverlay('29-pop-1')\n        }\n\n        function closeTwentyNinePopOne() {\n          hideOverlay('29-pop-1')\n        }\n\n        function showTwentyNinePopTwo() {\n          showOverlay('29-pop-2');\n          pg29Anim = new TimelineMax();\n          pg29Anim.fromTo(cOf(\"29-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[3])}}, 1.0)\n          .fromTo(cOf(\"29-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[4])}}, 1.1)\n          .fromTo(cOf(\"29-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[5])}}, 1)\n          .fromTo(cOf(\"29-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[6])}}, 1.1)\n          .fromTo(cOf(\"29-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[7])}}, 1)\n          .fromTo(cOf(\"29-no\")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"29-no\")[8])}}, 1.1);\n        }\n\n        function closeTwentyNinePopTwo() {\n          hideOverlay('29-pop-2');\n          pg29Anim.stop();\n          resetNumbers(\"29-no\");\n        }\n\n        function onPageLeave() {\n          pg29Anim.stop();\n          resetNumbers(\"29-no\");\n          closeTwnetyNinePopOne();\n          closeTwnetyNinePopTwo();\n          removeContentLinks()\n        }\n      ",
    "searchText": "OUR REDUCTION EFFORTS Overall, our carbon emissions fell by 18% compared with the 2023/24 Season and by 18% against our 2018 baseline year. Average emissions per race decreased from 2,075.75 tCO₂e in the 2023/24 Season to 1,699.13 tCO₂e in the 2024/25 Season. While freight has remained our largest source of emissions since the first season in 2014/15, we reduced freight-related emissions by 28% compared with the 2023/24 Season. A key driver of this improvement was reducing our air freight operations from three aircraft to two during the 2024/25 Season, delivering significant carbon savings while also reducing logistics costs by millions of pounds.  We achieved this by prioritising grid connection as the most efficient energy source – backed by certified renewable sources – and swapping traditional fuels for clean biofuels such as Hydrotreated Vegetable Oil (HVO) in all temporary generators, supplemented by solar energy and battery storage. We also reduced operational emissions by 20% to 1,204 tCO₂e. This was driven by a greater use of remote production, alongside continued improvements in energy efficiency and increased use of renewable energy.  18% reduction in overall emissions  28% drop in freightrelated emissions  decrease in operational emissions  CLICK TO READ ABOUT OUR FOCUS ON FREIGHT  FORMULA ENVIRONMENT  2024/25 SEASON V 2023/24 SEASON  20%  The 2024/25 Season marked our first season running on 100% renewable energy to power all races.  29  CLICK TO READ ABOUT ADDRESSING OUR RESIDUAL EMISSIONS  2024/25 SEASON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:406px; left:1159px; width:84px; height:86px;\"></div>  \n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg30Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "5 FORMULA FORMULA FORMULA FORMULA  ECOSYSTEM"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg5Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "BRINGING DIFFERENT PARTS OF OUR ECOSYSTEM TOGETHER TO TURN INDIVIDUAL EFFORTS INTO COLLECTIVE PROGRESS.  Formula E is built around speed. And speed is exactly what the world needs if we are to create a more sustainable and equitable future.  Our partners, teams and host cities give us an ecosystem through which we can help accelerate sustainable human progress. Across that network are some of the world’s leading minds in technology, mobility, energy, business and sustainability – each bringing ideas, expertise and solutions that can contribute to tackling shared challenges. Our role is to help connect them. By creating opportunities for collaboration, sharing knowledge and bringing different parts of our ecosystem together, we can help turn individual efforts into collective progress.  31  FORMULA ECOSYSTEM  2024/25 SEASON  THIS SECTION OF THE REPORT  VALUE THROUGH VALUES  PARTNERS ON OUR NET ZERO JOURNEY Exploring how Google Cloud, DHL and Infosys help us reduce hard-to-abate emissions. ENVISION RACING NAMED SUSTAINABILITY CHAMPION Ambition and results of the team’s Race Against Climate Change programme wins recognition. CONVERSATIONS TO UNLOCK IDEAS Change.Accelerated.Live brought more leaders together to drive innovative conversations and ideas for climate action."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n\n      <h1 id=\"32-no\" class=\"abs feSans-miniBd 32-no\" style=\"top:27px;left:351px; font-size: 8.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 6}' ></h1>\n\n      <h1 id=\"32-no\" class=\"abs feSans-miniBd 32-no\" style=\"top:362px;left:626px; font-size: 8.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 422}' ></h1>\n      <img class=\"abs halfScale 32-symbol\" style=\"top:403px;left:953px;\" src=\"/season2024-25/static/_content/m-symbol.png\"/>\n\n      <h1 id=\"32-no\" class=\"abs feSans-miniBd 32-no\" style=\"top:543px;left:704px; font-size: 8.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1.39, \"decimals\" : 2}' ></h1>\n      <img class=\"abs halfScale 32-symbol\" style=\"top:586px;left:1043px;\" src=\"/season2024-25/static/_content/bn.png\"/>\n\n      <h1 id=\"32-no\" class=\"abs feSans-miniBd 32-no\" style=\"top:590px;left:343px; font-size: 8.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 58}' ></h1>\n      <img class=\"abs halfScale 32-perc\" style=\"top:632px;left:567px;\" src=\"/season2024-25/static/_content/percentage.png\"/>\n      <img class=\"abs halfScale 32-perc\" style=\"top:607px;left:663px;\" src=\"/season2024-25/static/_content/32-block-1.png\"/>\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg32Anim = new TimelineMax();\n          pg32Anim.fromTo(cOf(\"32-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"32-no\")[0])}}, 1.0)\n          .fromTo(cOf(\"32-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"32-no\")[1])}}, 1.1)\n          .fromTo(cOf(\"32-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"32-no\")[2])}}, 1.2)\n          .fromTo(cOf(\"32-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"32-no\")[3])}}, 1.3);\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          pg32Anim.stop();\n          resetNumbers(\"32-no\");\n          removeContentLinks()\n        }\n      ",
    "searchText": "FORMULA FORMULA FORMULA FORMULA  6  CHANGE.ACCELERATED.LIVE EVENTS IN - MIAMI - MONACO  - TOKYO - SHANGHAI  - JAKARTA - LONDON  ECOSYSTEM S_11  422 BN % 1.39 58 IN NUMBERS IN NUMBERS IN NUMBERS IN NUMBERS  FORMULA ECOSYSTEM  M  FANS – A 13% INCREASE ON 2023/24 SEASON  OF FANS ‘HIGHLY ENGAGED’  32  ENVISION RACING RECOGNISED AS FORMULA E SUSTAINABILITY CHAMPION  2024/25 SEASON  DIGITAL IMPRESSIONS – A 14% INCREASE ON 2023/24 SEASON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "\n      \n      <!-- pop one -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 33-click-1\" style=\"top:681px;left:228px;\" onclick=\"showThirtyThreePopOne()\" src=\"/season2024-25/static/_content/33-click-1.png\"/>\n      <div id=\"33-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 33-pop-1\" style=\"top:52px;left:50px;\" src=\"/season2024-25/static/_content/33-pop-1.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:81px;left:1143px;width:43px;height:43px;\" onclick=\"hideOverlay('33-pop-1')\"></div>\n      </div>\n\n      <!-- pop two -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 33-click-2\" style=\"top:681px;left:538px;\" onclick=\"showThirtyThreePopTwo()\" src=\"/season2024-25/static/_content/33-click-2.png\"/>\n      <div id=\"33-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 33-pop-2\" style=\"top:52px;left:50px;\" src=\"/season2024-25/static/_content/33-pop-2.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:81px;left:1143px;width:43px;height:43px;\" onclick=\"hideOverlay('33-pop-2')\"></div>\n      </div>\n\n      <!-- pop three -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 33-click-3\" style=\"top:681px;left:848px;\" onclick=\"showThirtyThreePopThree()\" src=\"/season2024-25/static/_content/33-click-3.png\"/>\n      <div id=\"33-pop-3\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 33-pop-3\" style=\"top:52px;left:50px;\" src=\"/season2024-25/static/_content/33-pop-3.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:81px;left:1143px;width:43px;height:43px;\" onclick=\"hideOverlay('33-pop-3')\"></div>\n      </div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg33Anim = new TimelineMax();\n\n          setTimeout(function(){\n                addContentLinks();\n            },1000)\n        }\n\n        function showThirtyThreePopOne() {\n          showOverlay('33-pop-1')\n        }\n\n        function closeThirtyThreePopOne() {\n          hideOverlay('33-pop-1')\n        }\n\n        function showThirtyThreePopTwo() {\n          showOverlay('33-pop-2')\n        }\n\n        function closeThirtyThreePopTwo() {\n          hideOverlay('33-pop-2')\n        }\n\n        function showThirtyThreePopThree() {\n          showOverlay('33-pop-3')\n        }\n\n        function closeThirtyThreePopThree() {\n          hideOverlay('33-pop-3')\n        }\n\n        function onPageLeave() {\n          pg33Anim.stop();\n          resetNumbers(\"33-no\");\n          closeThirtyThreePopOne();\n          closeThirtyThreePopTwo();\n          closeThirtyThreePopThree();\n          removeContentLinks()\n        }\n      ",
    "searchText": "PARTNERS ON OUR JOURNEY TO NET ZERO Achieving net zero requires collaboration. We work with partners that bring the expertise, technology and ambition needed to help us reduce hard-to-abate emissions, improve operational efficiency and unlock new solutions to sustainability challenges across the Championship.  33  FORMULA ECOSYSTEM  MAKING DATA ANALYSIS LESS CARBON INTENSIVE WITH GOOGLE CLOUD  TAKING SIGNIFICANT STEPS TO REDUCE FREIGHT EMISSIONS WITH DHL  AI TO IDENTIFY CARBON REDUCTION OPPORTUNITIES WITH INFOSYS  CLICK TO READ  CLICK TO READ  CLICK TO READ  2024/25 SEASON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n\n      <h1 id=\"34-no\" class=\"abs feSans-miniBd 34-no\" style=\"top:657px;left:422px; font-size: 3.34em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 10, \"append\" : \"%\"}' ></h1>\n\n      <h1 id=\"34-no\" class=\"abs feSans-miniBd 34-no\" style=\"top:657px;left:717px; font-size: 3.34em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 5}' ></h1>\n      \n      <!-- pop one -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 34-click-1\" style=\"top:568px;left:-87px;\" onclick=\"showThirtyFourPopOne()\" src=\"/season2024-25/static/_content/34-click-1.png\"/>\n      <div id=\"34-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 34-pop-1\" style=\"top:385px;left:35px;\" src=\"/season2024-25/static/_content/34-pop-1.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:590px;left:56px;width:285px;height:43px;\" onclick=\"hideOverlay('34-pop-1')\"></div>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:714px;left:1127px;width:43px;height:43px;\" onclick=\"hideOverlay('34-pop-1')\"></div>\n      </div>\n\n      <!-- pop two -->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 34-click-2\" style=\"top:633px;left:-101px;\" onclick=\"showThirtyFourPopTwo()\" src=\"/season2024-25/static/_content/34-click-2.png\"/>\n      <div id=\"34-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 34-pop-2\" style=\"top:52px;left:50px;\" src=\"/season2024-25/static/_content/34-pop-2.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:81px;left:1143px;width:43px;height:43px;\" onclick=\"hideOverlay('34-pop-2')\"></div>\n      </div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          pg34Anim.fromTo(cOf(\"34-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[0])}}, 1.0)\n          .fromTo(cOf(\"34-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"34-no\")[1])}}, 1.1);\n\n          setTimeout(function(){\n                addContentLinks();\n            },1000)\n        }\n\n        function showThirtyFourPopOne() {\n          showOverlay('34-pop-1')\n        }\n\n        function closeThirtyFourPopOne() {\n          hideOverlay('34-pop-1')\n        }\n\n        function showThirtyFourPopTwo() {\n          showOverlay('34-pop-2')\n        }\n\n        function closeThirtyFourPopTwo() {\n          hideOverlay('34-pop-2')\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop();\n          resetNumbers(\"34-no\");\n          closeThirtyFourPopOne();\n          closeThirtyFourPopTwo();\n          removeContentLinks()\n        }\n      ",
    "searchText": "ENVISION RACING NAMED SUSTAINABILITY CHAMPION Our teams have the opportunity to use their platforms, partnerships and expertise to accelerate change, and in the 2024/25 Season, Envision Racing demonstrated what that can look like at its best. Envision Racing was named Formula E’s Sustainability Champion following its most ambitious season of sustainability activity to date. Through its Race Against Climate Change (RACC) programme, the team combined action to reduce its own environmental impact with a global campaign designed to engage people in climate solutions.  CLICK TO READ MORE  CLICK TO READ ABOUT MAHINDRA PLANET POSITIVE PROGRAMME  34  FORMULA ECOSYSTEM  10%  carbon emissions reduction against it baseline  2024/25 SEASON  5  Race Against Climate Change events hosted  Sustainability Working Group established"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "\n      \n      <!-- pop one -->\n      <img class=\"abs halfScaleC pointer 35-click-1\" style=\"top:66px;left:243px;\" onclick=\"showThirtyFivePopOne()\" src=\"/season2024-25/static/_content/35-click-1.png\"/>\n      <div id=\"35-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 35-pop-1\" style=\"top:52px;left:51px;\" src=\"/season2024-25/static/_content/35-pop-1.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:83px;left:83px;width:43px;height:43px;\" onclick=\"hideOverlay('35-pop-1')\"></div>\n      </div>\n\n      <!-- pop two -->\n      <img class=\"abs halfScaleC pointer 35-click-2\" style=\"top:66px;left:522px;\" onclick=\"showThirtyFivePopTwo()\" src=\"/season2024-25/static/_content/35-click-2.png\"/>\n      <div id=\"35-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 35-pop-2\" style=\"top:52px;left:51px;\" src=\"/season2024-25/static/_content/35-pop-2.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:83px;left:83px;width:43px;height:43px;\" onclick=\"hideOverlay('35-pop-2')\"></div>\n      </div>\n\n      <!-- pop three -->\n      <img class=\"abs halfScaleC pointer 35-click-3\" style=\"top:66px;left:800px;\" onclick=\"showThirtyFivePopThree()\" src=\"/season2024-25/static/_content/35-click-3.png\"/>\n      <div id=\"35-pop-3\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 35-pop-3\" style=\"top:52px;left:51px;\" src=\"/season2024-25/static/_content/35-pop-3.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:83px;left:1138px;width:43px;height:43px;\" onclick=\"hideOverlay('35-pop-3')\"></div>\n      </div>\n\n      <!-- pop four -->\n      <img class=\"abs halfScaleC pointer 35-click-4\" style=\"top:351px;left:243px;\" onclick=\"showThirtyFivePopFour()\" src=\"/season2024-25/static/_content/35-click-4.png\"/>\n      <div id=\"35-pop-4\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 35-pop-4\" style=\"top:52px;left:51px;\" src=\"/season2024-25/static/_content/35-pop-4.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:83px;left:83px;width:43px;height:43px;\" onclick=\"hideOverlay('35-pop-4')\"></div>\n      </div>\n\n      <!-- pop five -->\n      <img class=\"abs halfScaleC pointer 35-click-5\" style=\"top:351px;left:521px;\" onclick=\"showThirtyFivePopFive()\" src=\"/season2024-25/static/_content/35-click-5.png\"/>\n      <div id=\"35-pop-5\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 35-pop-5\" style=\"top:52px;left:51px;\" src=\"/season2024-25/static/_content/35-pop-5.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:83px;left:83px;width:43px;height:43px;\" onclick=\"hideOverlay('35-pop-5')\"></div>\n      </div>\n\n      <!-- pop six -->\n      <img class=\"abs halfScaleC pointer 35-click-6\" style=\"top:351px;left:799px;\" onclick=\"showThirtyFivePopSix()\" src=\"/season2024-25/static/_content/35-click-6.png\"/>\n      <div id=\"35-pop-6\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 35-pop-6\" style=\"top:52px;left:51px;\" src=\"/season2024-25/static/_content/35-pop-6.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:83px;left:83px;width:43px;height:43px;\" onclick=\"hideOverlay('35-pop-6')\"></div>\n      </div>\n\n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg35Anim = new TimelineMax();\n\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function showThirtyFivePopOne() {\n          showOverlay('35-pop-1')\n        }\n\n        function closeThirtyFivePopOne() {\n          hideOverlay('35-pop-1')\n        }\n\n        function showThirtyFivePopTwo() {\n          showOverlay('35-pop-2')\n        }\n\n        function closeThirtyFivePopTwo() {\n          hideOverlay('35-pop-2')\n        }\n\n         function showThirtyFivePopThree() {\n          showOverlay('35-pop-3')\n        }\n\n        function closeThirtyFivePopThree() {\n          hideOverlay('35-pop-3')\n        }\n\n        function showThirtyFivePopFour() {\n          showOverlay('35-pop-4')\n        }\n\n        function closeThirtyFivePopFour() {\n          hideOverlay('35-pop-4')\n        }\n\n        function showThirtyFivePopFive() {\n          showOverlay('35-pop-5')\n        }\n\n        function closeThirtyFivePopFive() {\n          hideOverlay('35-pop-5')\n        }\n\n        function showThirtyFivePopSix() {\n          showOverlay('35-pop-6')\n        }\n\n        function closeThirtyFivePopSix() {\n          hideOverlay('35-pop-6')\n        }\n\n        function onPageLeave() {\n          pg35Anim.stop();\n          resetNumbers(\"35-no\");\n          closeThirtyFivePopOne();\n          closeThirtyFivePopTwo();\n          closeThirtyFivePopThree();\n          closeThirtyFivePopFour();\n          closeThirtyFivePopFive();\n          closeThirtyFivePopSix();\n          removeContentLinks()\n        }\n      ",
    "searchText": "CONVERSATIONS TO UNLOCK IDEAS Through Change. Accelerated. Live., we use our global platform to bring together leaders from business, government, technology and sport to explore how innovation can help address climate change and accelerate positive change. Taking place alongside races in cities around the world, each event focuses on the challenges and opportunities most relevant to its location – from the future of mobility and smart cities to artificial intelligence, climate finance and sustainable innovation. By connecting different industries, perspectives and areas of expertise, we aim to create conversations that can unlock new ideas, strengthen collaboration and help turn ambition into action across business and society.  35  FORMULA ECOSYSTEM  CLICK BELOW TO READ EACH EVENT FOCUSES  DIGITAL FUTURES MIAMI  SMART CITIES MONACO  REIMAGINING TRANSPORTATION TOKYO  INNOVATION IN MOTION SHANGHAI  CHANGE. ACCELERATED.LIVE JAKARTA  SUSTAINABLE INNOVATION LONDON  2024/25 SEASON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:406px; left:1159px; width:84px; height:86px;\"></div>  \n\n      ",
    "script": "\n        function onPageEnter() {\n          pg36Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "6 GRI GRI GRI GRI  INDEX"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n      \n      <!--- scrollable table --->\n\n      <div id=\"scrollable-container\" class=\"abs scroll-container\" style=\"width: 1080px; height: 383px; top: 315px; left: 67px; overflow-y: scroll;\">\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-1.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-2.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-3.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-4.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-5.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-6.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-7.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-8.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-9.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-10.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-11.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-12.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-13.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-14.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-15.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-16.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-17.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-18.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-19.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-20.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-21.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-22.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-23.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-24.jpg\"/>\n        <img style=\"width: 100%; height: auto; position: relative;\" src=\"/season2024-25/static/_content/pdf-25.jpg\"/>\n      </div>\n\n      <!--- clickable tab --->\n      <img class=\"abs halfScaleC halfpulse animatedpulse pointer 37-tab\" style=\"top:744px;left:207px;\" src=\"/season2024-25/static/_content/37-click-tab.png\"/>\n\n      <a href=\"https://sustainabilityreport.fiaformulae.com/season2024-25/static/_content/gri_content_index_table_final.pdf\" target=\"_blank\" class=\"contentLinkNone\">\n        <img class=\"abs halfScaleC halfpulse animatedpulse pointer 37-tab\" style=\"top:744px;left:207px;\" src=\"/season2024-25/static/_content/37-click-tab.png\"/>\n      </a>\n            \n      <div class=\"addContentLink\" onclick=\"Publish.goToNextPage();\" style=\"top:430px; left:1231px; width:33px; height:35px;\"></div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          pg37Anim = new TimelineMax();\n\n          setTimeout(function(){\n              addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "GRI  CONTENT INDEX GRI CONTENT INDEX  Formula E has reported the information cited in this GRI content index for the period 28th January 2024 - 14th August 2025 with reference to the GRI Standards.  Formula E has reported the information cited in this GRI content index for the period 28th January 2023 – 14th August 2024 with reference to the GRI Standards.  SCROLL TO READ TABLE  GRI STANDARDS  DISCLOSURE  LOCATION  bn2-1 Organizational details  2-1-a Organisation legal name – Formula E Operations Limited 2-1-b Ownership and legal form On 20th February 2013, Formula E Operations Limited was incorporated under the Companies Act 2006 as a private limited company with its registered office in England. Shares are owned by Formula E Holdings Limited (Hong Kong).  General disclosures GRI 2: General Disclosures 2021  2-1-c Location of Headquarters Formula E Operations Limited and Formula E Race Operations, 3 Shortlands, 9th Floor, London, W6 8DA, United Kingdom. 2-1-d Countries of operations London Headquarters: Formula E Operations Limited and Formula E Race Operations, 3 Shortlands, 9th Floor, London, W6 8DA, United Kingdom. Hong Kong Office: Formula E Holdings Limited, Level 54, Hopewell Centre, 183 Queen’s Road East, Hong Kong. Mexico City Office: Formula E Mexico Race Operations S De RL DE CV, Avenida Ejercito Nacional, No. 418-307, Polanco V Sección, Miguel Hidalgo, C.P. 11560 Ciudad de México, Mexico. US Office: 28 Old Rudnick Lane, Dover, Delaware, US, 19901 Brazil Office: Alameda Santos 1293, Sao Paulo, 01419-904 Sao Paulo, Brazil Japan Office: c/o Ark Outsourcing KK, 4-3-5-704, Ebisu, Shibuya-ku, Tokyo, Japan 2-3 Reporting period, frequency and contact point  1  37  GRI INDEX  GRI INDEX  2-3-a Reporting period and frequency – 1st October 2023 to 30th September 2024 2-3-b Financial reporting period: 28th January 2023 – 14th August 2024 2-3-c Publish date – April/May 2025 2-3-d Contact point for questions regarding the report – sustainabilty@fiaformulae.com  OF FANS CLICK ‘HIGHLYTO ENGAGED’ DOWNLOAD FULL TABLE SEASON 10 SUSTAINABILITY REPORT  2024/25 SEASON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n    function idOf(id) {\n      return document.getElementById(id)\n    }\n\n    function cOf(klass) {\n      return document.getElementsByClassName(klass)\n    }\n\n    function removeContentLinks() {\n      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n      contentLinks.map(function callback(e) {\n        return e.className = 'addContentLink'\n      })\n    }\n\n    function addContentLinks() {\n      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n      contentLinks.map(function callback(e) {\n        return e.className = 'contentLink addContentLink'\n      })\n    }\n\n    function showOverlay(idx) {\n      idOf(idx).className = 'contentOverlay visible'\n    }\n\n    function hideOverlay(idx) {\n      idOf(idx).className = 'contentOverlay hidden noclick'\n    }\n\n    function animateNumber(element){\n      if(element.getAttribute(\"data-number\")){\n        var args = JSON.parse(element.getAttribute(\"data-number\"));\n        var from = 0;\n        var to = 100;\n        var append = \"\";\n        var preppend = \"\";\n        var decimals = 0;\n        var duration = 1;\n        var ease = \"Linear.easeNone\";\n        var comma = false;\n        var separator = \",\";\n        var decChar = \".\";\n        for(obj in args){\n          if(obj == \"from\") from = args[obj];\n          if(obj == \"to\") to = args[obj];\n          if(obj == \"append\") append = args[obj];\n          if(obj == \"preppend\") preppend = args[obj];\n          if(obj == \"decimals\") decimals = args[obj];\n          if(obj == \"duration\") duration = args[obj];\n          if(obj == \"ease\") ease = args[obj];\n          if(obj == \"comma\") comma = args[obj];\n          if(obj == \"separator\") separator = args[obj];\n          if(obj == \"decChar\") decChar = args[obj];\n        }\n        var obj = {number: from}\n        TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n          if(comma){\n            console.log(obj.number)\n            var str = obj.number.toFixed(decimals).toString();\n            var predec = str.split(/^d*/)[0];\n            console.log(\"PREDEC\", predec, typeof(predec));\n            var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n            var comp = newstr.replace(/^,/, '')\n            console.log(\"NEWSTR\", newstr, typeof(newstr));\n            // console.log({newstr})\n            // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n            // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n            var dp = \"\";\n            element.innerHTML = preppend+comp+dp+append;\n          }else{\n            element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n          }\n        }, ease: eval(ease)});\n      }else{\n        return;\n      }\n    }\n\n    function resetNumbers(ele){\n      var numbers = cOf(ele)\n      for(var i=0; i<numbers.length; i++) {\n        numbers[i].innerText= \"\"\n      }\n    }\n\n    function mailChimpSubmit(){\n      $('#mc-embedded-subscribe-form').submit(function (e) {\n        var that = $(this);\n        var mailchimpSubmit = $(this).find('input[type=submit]');\n        var errorResponse = $('#mce-error-response');\n        var successResponse = $('#mce-success-response');\n\n        e.preventDefault();\n\n        $.ajax({\n          method: 'GET',\n          url: that.attr('action'),\n          data: that.serialize(),\n          dataType: 'jsonp',\n          success: function(data) {\n            console.log('AJAX SUCCESS')\n          // If there was an error then show the error message.\n            if (data.result === 'error') {\n              console.log('AJAX ERROR')\n              // If the error has an error code at front then alter the message to not include the error code and hyphen.\n              if(data.msg.indexOf('0') === 0) {\n                data.msg = data.msg.slice(3);\n              }\n              errorResponse.html(data.msg).fadeIn(300).delay(3000).fadeOut(300);\n            }\n            // If success then show message\n            else {\n              successResponse.html('Thank you for subscribing!').fadeIn(300).delay(3000).fadeOut(300);\n            }\n          }\n        });\n      });\n    }\n  ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    if (context.getters.contentsPinned) {
      if (payload.width < 992) {
        var windowWidth = payload.width;
        var mobile = true;
      } else {
        var windowWidth = payload.width - 300;
        var mobile = false;
      }
    } else {
      var windowWidth = payload.width;
    }
    var windowHeight = payload.height - 60;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
    if (context.getters.contentsPinned) {
      if (windowWidth <= 992 && mobile) {
        context.commit('UPDATE_CONTENT_PANEL', false);
      } else {
        context.commit('UPDATE_CONTENT_PANEL', true);
      }
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  scrollZoom: function scrollZoom(context, payload) {
    var zoomLevel = context.state.zoomLevel + payload.zoomDelta;
    zoomLevel = zoomLevel > 2 ? 2 : zoomLevel;
    zoomLevel = zoomLevel < 1 ? 1 : zoomLevel;
    var windowWidthAdjustment = context.getters.contentsPinned ? 300 : 0;
    var newX = payload.x - (window.innerWidth - windowWidthAdjustment) / 2;
    var newY = payload.y - (window.innerHeight + 48) / 2;
    var translateX = context.state.translateX + (newX - context.state.zoomOriginX) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));
    var translateY = context.state.translateY + (newY - context.state.zoomOriginY) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));

    console.log({ zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });

    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  titledPages: function titledPages(state) {
    return state.document.pages.filter(function (page) {
      return page[0].title;
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state, getters) {
    return state.activePanel == "Contents" || getters.contentsPinned;
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isMobileFontLarge: function isMobileFontLarge(state) {
    return state.isMobileFontLarge;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contents.enabled;
  },
  contentsPinned: function contentsPinned(state, getters) {
    return state.document.options.contents.pinned && getters.contentsEnabled && !getters.isMobile && !getters.isFullscreen;
  },
  contentsNumbers: function contentsNumbers(state) {
    return state.document.options.contents.numbers;
  },
  contentsTitles: function contentsTitles(state) {
    return state.document.options.contents.titles;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomNavEnabled: function zoomNavEnabled(state) {
    return state.document.options.zoom.navEnabled;
  },
  zoomClickEnabled: function zoomClickEnabled(state) {
    return state.document.options.zoom.clickEnabled;
  },
  zoomScrollEnabled: function zoomScrollEnabled(state) {
    return state.document.options.zoom.scrollEnabled;
  },
  zoomSliderEnabled: function zoomSliderEnabled(state) {
    return state.document.options.zoom.sliderEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoom.navEnabled || state.document.options.zoom.clickEnabled || state.document.options.zoom.scrollEnabled || state.document.options.zoom.sliderEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  fullscreenEnabled: function fullscreenEnabled(state) {
    return state.document.options.fullscreenEnabled && document.documentElement.requestFullscreen;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {};

    styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";

    styleObject.transform = "scale(" + getters.pageContainerZoomLevel * state.pageScale + ") translate(" + state.translateX + "px, " + state.translateY + "px)";

    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// CONCATENATED MODULE: ./src/store/mutations.js



var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FONT_SIZE, function (state) {
  state.isMobileFontLarge = !state.isMobileFontLarge;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FULLSCREEN, function (state) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    state.isFullscreen = true;
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_FULLSCREEN, function (state) {
  if (document.fullscreenElement || window.fullscreenElement) {
    state.isFullscreen = true;
  } else {
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.translateX = payload.translateX || state.translateX;
  state.translateY = payload.translateY || state.translateY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;

  if (state.zoomLevel <= 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
    state.translateX = 0;
    state.translateY = 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, SLIDE_ZOOM, function (state, payload) {
  var zoomDelta = payload.zoomValue - state.zoomLevel;

  if (zoomDelta < 0) {
    var zoomDeltaScale = zoomDelta / (1 - state.zoomLevel);
    state.zoomOriginX = state.zoomOriginX * (1 - zoomDeltaScale);
    state.zoomOriginY = state.zoomOriginY * (1 - zoomDeltaScale);
  }

  state.zoomLevel = payload.zoomValue || state.zoomLevel;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_CONTENT_PANEL, function (state, payload) {
  state.contentsPanel = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var contents_state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: contents_state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    contentsPanel: true,
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    translateX: 0,
    translateY: 0,
    isDoublePage: false,
    isFullscreen: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isMobileFontLarge: false
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("wheel", this.mouseWheelHandler, { passive: false });
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed && mouse.y > 50) {
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.ctrlKey) {
      e.preventDefault();
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      if (e.wheelDelta > 0) {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: 0.08
        });
      } else {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: -0.08
        });
      }
    } else {
      if (e.wheelDelta > 0) {
        Publish.goToPreviousSection();
      } else {
        Publish.goToNextSection();
      }
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomClickEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
    document.addEventListener('fullscreenchange', this.updateFullscreen);
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  updateFullscreen: function updateFullscreen() {
    Publish.updateFullscreen();
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-K8HCFQTT76" }
}, router);

/* eslint-disable no-new */
window.Publish = new vue_esm["default"]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "zoomClickEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM",
    updateFullscreen: "UPDATE_FULLSCREEN"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "scrollZoom", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "OT+5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Om6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WpSr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1YF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dUvF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hIWI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hLNX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hxKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ij1X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kzGI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lJM2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lsaJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nSix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o4GY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.445a06ab79f05207994f.js